webpackJsonp([1],{

/***/ "+Emi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_models_page_model__ = __webpack_require__("yu3g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_collection_model__ = __webpack_require__("A7kh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");





/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ApplyPage",
	data: function data() {
		return {
			content: [],
			items: [],
			url: window.location.href
		};
	},

	props: {},
	created: function created() {
		this.getContent();
	},

	watch: {
		"$route": function $route() {
			this.url = window.location.href;
			this.getContent();
		}
	},
	mounted: function mounted() {
		setTimeout(function () {
			__WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("evalColors", true);
		}, 200);
	},

	computed: {},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var contentReady = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_1__data_models_page_model__["a" /* getTemplatePage */])('pages/about-page.php').then(function (content) {
					_this.content = content;
					_this.isReady = true;
					__WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("evalColors", true);
					__WEBPACK_IMPORTED_MODULE_3__main__["bus"].$emit("PAGE_IS_READY", true);
				});
			});
		}
	}
});

/***/ }),

/***/ "+vI6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"publication-page",style:('--openSection:' + _vm.openSection + '; --main-color:' + _vm.content.color + '; --text-color:' + _vm.content.textColor),attrs:{"id":"publication-page"}},[_c('vue-headful',{attrs:{"title":_vm.content.title,"ogTitle":_vm.content.title,"description":_vm._f("stripHtml")(_vm.content.subTitle),"ogDescription":_vm._f("stripHtml")(_vm.content.subTitle),"image":_vm.content.image.sizes.large ? _vm.content.image.sizes.large : _vm.content.image.sizes.original,"ogImage":_vm.content.image.sizes.large ? _vm.content.image.sizes.large : _vm.content.image.sizes.original,"url":_vm.url}}),_c('header',{staticClass:"publication-page__content element-colorize",attrs:{"id":"general","data-logo-color":"#000"}},[_c('h1',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.content.title))]),_c('h2',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.content.subTitle))]),_c('nav',{staticClass:"publication-page__content__actions"},[_c('a',{staticClass:"type--caption type--uppercase link",attrs:{"href":_vm.content.url}},[_vm._v(_vm._s(_vm.$t("store.buy", _vm.language))+" "),(_vm.content.price)?_c('span',[_vm._v("— ")]):_vm._e(),(_vm.content.price)?_c('span',[_vm._v(_vm._s(_vm.content.price)+"€")]):_vm._e()]),(_vm.content.pdf)?_c('button',{staticClass:"type--caption type--uppercase link",on:{"click":function($event){return _vm.scrollTo('viewer')}}},[_vm._v(_vm._s(_vm.$t("buttons.view", _vm.language)))]):_vm._e(),(_vm.content.info.length)?_c('button',{staticClass:"type--caption type--uppercase link",on:{"click":function($event){return _vm.scrollTo('credits')}}},[_vm._v(_vm._s(_vm.$t("buttons.credits", _vm.language)))]):_vm._e()])]),_c('section',{staticClass:"publication-page__gallery element-colorize",attrs:{"data-logo-color":"#000"}},_vm._l((_vm.content.gallery),function(image,index){return _c('div',{staticClass:"image"},[_c('image-block',{key:image.id,attrs:{"source":image,"wordpress":"wordpress"}})],1)}),0),_c('aside',{staticClass:"publication-page__credits",attrs:{"id":"credits"}},_vm._l((_vm.content.info),function(group){return _c('dl',_vm._l((group.content),function(item){return _c('div',[_c('dt',{staticClass:"type--italic type--body"},[_vm._v(_vm._s(item.title))]),_c('dd',{staticClass:"type--body"},[_vm._v(_vm._s(item.value))])])}),0)}),0),_c('nav',{staticClass:"publication-page__nav"},[_c('router-link',{staticClass:"type--caption type--uppercase link",attrs:{"to":{ name: 'PublicationsPage' }}},[_vm._v(_vm._s(_vm.$t('pages.store', _vm.language)))]),_c('span',[_vm._v(" — ")]),_c('button',{staticClass:"type--caption type--uppercase link",class:{ 'active' : _vm.activeSection == 'general' },on:{"click":function($event){return _vm.scrollTo('general')}}},[_vm._v(_vm._s(_vm.$t('buttons.info', _vm.language)))]),(_vm.content.pdf)?_c('span',[_vm._v(" · ")]):_vm._e(),(_vm.content.pdf)?_c('button',{staticClass:"type--caption type--uppercase link",class:{ 'active' : _vm.activeSection == 'viewer' },on:{"click":function($event){return _vm.scrollTo('viewer')}}},[_vm._v(_vm._s(_vm.$tc('pages.publications', 1, _vm.language)))]):_vm._e(),_c('span',[_vm._v(" · ")]),(_vm.content.info.length)?_c('button',{staticClass:"type--caption type--uppercase link",class:{ 'active' : _vm.activeSection == 'credits' },on:{"click":function($event){return _vm.scrollTo('credits')}}},[_vm._v(_vm._s(_vm.$t('buttons.colophon', _vm.language)))]):_vm._e()],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Kbq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_playground_page_js__ = __webpack_require__("nORL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f79e64f_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_playground_page_vue__ = __webpack_require__("xksy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_playground_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f79e64f_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_playground_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "/xNW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_archive_page_js__ = __webpack_require__("PZFy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d353c42e_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_archive_page_vue__ = __webpack_require__("mbck");
function injectStyle (ssrContext) {
  __webpack_require__("7w6h")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d353c42e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_archive_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d353c42e_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_archive_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "044V":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{domProps:{"innerHTML":_vm._s(_vm.src)}})}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "0csj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('section',{staticClass:"news-page element-colorize",attrs:{"data-logo-color":'#000'}},[_c('header',{staticClass:"news-page__header"},[_c('div',{staticClass:"news-page__header__title"},[_c('h1',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.$t('pages.news', _vm.lang)))])]),_c('ul',_vm._l((_vm.content),function(article){return _c('li',{staticClass:"article"},[(article.slug !== _vm.articleSlug)?_c('router-link',{attrs:{"to":{ name: 'NewsPage', params: { article: article.slug } }}},[_c('time',{staticClass:"article__time type--display_1",class:{ 'inactive' : _vm.articleSlug != article.slug && _vm.articleSlug }},[_vm._v(_vm._s(_vm._f("date")(article.date,'short', null, ['/', '.'])))]),_c('h1',{staticClass:"article__title type--display_1 link",class:{ 'inactive' : _vm.articleSlug != article.slug && _vm.articleSlug }},[_vm._v(_vm._s(article.title))])]):_vm._e(),(article && article.slug === _vm.articleSlug)?_c('article',{key:article.slug,staticClass:"news-page__article mobile"},[_c('vue-headful',{attrs:{"title":article.title,"ogTitle":article.title,"description":_vm._f("stripHtml")(article.excerpt),"ogDescription":_vm._f("stripHtml")(article.excerpt),"image":article.image.sizes.large ? article.image.sizes.large : article.image.sizes.original,"ogImage":article.image.sizes.large ? article.image.sizes.large : article.image.sizes.original,"url":_vm.url}}),_c('time',{staticClass:"type--display_2"},[_vm._v(_vm._s(_vm._f("date")(article.date,'short', null, ['/', '.'])))]),_c('h1',{staticClass:"type--display_2"},[_vm._v(_vm._s(article.title))]),_c('h2',{staticClass:"type--display_2",domProps:{"innerHTML":_vm._s(article.excerpt)}}),_c('div',[(article.image)?_c('image-block',{staticClass:"news-page__article__image expand",attrs:{"source":article.image,"wordpress":"true"}}):_vm._e()],1),_c('text-block',{staticClass:"news-page__article__text",attrs:{"source":article.content}})],1):_vm._e()],1)}),0),_c('nav',{staticClass:"news-page__header__actions"},[_c('h2',{staticClass:"news-page__header__actions__info type--button type--uppercase"},[_vm._v(_vm._s(_vm.content.length)+"—"+_vm._s(_vm.totalNews)+" "+_vm._s(_vm.$t('pages.news', _vm.lang)))]),(_vm.totalPages > _vm.currentPage)?_c('button',{staticClass:"link type--button type--uppercase",on:{"click":function($event){return _vm.getMoreContent(_vm.currentPage + 1)}}},[_vm._v(_vm._s(_vm.$t('buttons.more', _vm.lang )))]):_vm._e()])]),(_vm.article)?_c('article',{key:_vm.article.slug,staticClass:"news-page__article"},[_c('vue-headful',{attrs:{"title":_vm.article.title,"ogTitle":_vm.article.title,"description":_vm._f("stripHtml")(_vm.article.excerpt),"ogDescription":_vm._f("stripHtml")(_vm.article.excerpt),"image":_vm.article.image.sizes.large ? _vm.article.image.sizes.large : _vm.article.image.sizes.original,"ogImage":_vm.article.image.sizes.large ? _vm.article.image.sizes.large : _vm.article.image.sizes.original,"url":_vm.url}}),_c('time',{staticClass:"type--display_2"},[_vm._v(_vm._s(_vm._f("date")(_vm.article.date,'short', null, ['/', '.'])))]),_c('h1',{staticClass:"type--display_2"},[_vm._v(_vm._s(_vm.article.title))]),_c('h2',{staticClass:"type--display_2",domProps:{"innerHTML":_vm._s(_vm.article.excerpt)}}),_c('div',[(_vm.article.image)?_c('image-block',{staticClass:"news-page__article__image expand",attrs:{"source":_vm.article.image,"wordpress":"true"}}):_vm._e()],1),_c('text-block',{staticClass:"news-page__article__text",attrs:{"source":_vm.article.content}})],1):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1te6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_suggestions_page_js__ = __webpack_require__("CIx6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b48acf_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_suggestions_page_vue__ = __webpack_require__("IHky");
function injectStyle (ssrContext) {
  __webpack_require__("zbtW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64b48acf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_suggestions_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64b48acf_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_suggestions_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3Eyw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dateCdd;
function dateCdd(value, type, locale, separator) {
    if (!value) return;

    var evalSeparator = [separator ? separator[0] : "", separator ? separator[1] : ""];

    // More info: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
    var options = {
        long: {
            "weekday": "long",
            "year": "numeric",
            "month": "long",
            "day": "numeric"
        },
        normal: {
            "year": "numeric",
            "month": "long",
            "day": "numeric"
        },
        short: {
            "year": "numeric",
            "month": "numeric",
            "day": "numeric"
        },
        day: {
            "day": "numeric"
        },
        month: {
            "month": "long"
        },
        year: {
            "year": "numeric"
        }
    };

    return new Date(value).toLocaleString(locale || "en-GB", options[type]).replace(new RegExp(evalSeparator[0], "g"), evalSeparator[1] || evalSeparator[0]);
};

/***/ }),

/***/ "3f1H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-block",domProps:{"innerHTML":_vm._s(_vm.editedSource)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6HzD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6SEG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "71jN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Product; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var Product = function Product(object) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Product);

	// Identifier
	this.id = object.id || null;
	this.title = object.title.rendered || null;
	this.slug = object.slug || null;

	// Settings
	// this.color = object.meta_box.settings.color || null;

	// content
	this.date = object.date || null;
	this.subTitle = object.meta_box.content.sub_title || null;
	this.content = object.meta_box.content.content || null;
	this.excerpt = object.meta_box.content.short_content || null;
	this.info = object.meta_box.credits.info || null;

	// Product
	this.image = object.meta_box.content.image || null;
	this.gallery = object.meta_box.content.gallery || [];
	this.pdf = object.meta_box.content.pdf || null;

	// Buy
	this.url = object.meta_box.settings.url || null;
	this.price = object.meta_box.settings.price || null;
	this.type = object.meta_box.settings.type || null;

	// Relations
	this.exhibitions = object.meta_box.news_to_exhibitions_to || null;
	this.news = object.meta_box.news_to_products_to || null;
};

/***/ }),

/***/ "78FQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");


/* harmony default export */ __webpack_exports__["a"] = ({
	name: "App",
	data: function data() {
		return {
			menuIsOpen: false,
			isLoading: true
		};
	},

	watch: {
		// "$route": function() {process.env.NODE_ENV === "development" ? console.log(this.$route) : null}
		"$route": function $route() {
			this.menuIsOpen = false;
			this.isLoading = true;
		}
	},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("evalColors", function () {
			_this.isLoading = false;
		});
		__WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("toggleMenu", function (value) {
			if (value == false) _this.menuIsOpen = false;else _this.menuIsOpen = !_this.menuIsOpen;
		});
		__WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("PAGE_IS_READY", function (isReady) {
			document.documentElement.toggleAttribute("data-page-is-ready", isReady);
		});
	},

	methods: {}
});

/***/ }),

/***/ "7w6h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7znA":
/***/ (function(module, exports) {

module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\"><title>full_close</title><polyline points=\"16 0 16 16 0 16\" style=\"fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:6px\"></polyline><polyline points=\"48 16 32 16 32 0\" style=\"fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:6px\"></polyline><polyline points=\"32 48 32 32 48 32\" style=\"fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:6px\"></polyline><polyline points=\"0 32 16 32 16 48\" style=\"fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:6px\"></polyline></svg>"

/***/ }),

/***/ "83xS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_text_block_js__ = __webpack_require__("AjY1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f76b8a_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_text_block_vue__ = __webpack_require__("3f1H");
function injectStyle (ssrContext) {
  __webpack_require__("azah")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_text_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f76b8a_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_text_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8aC8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_product_block_js__ = __webpack_require__("NlmE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e61a1d0a_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_product_block_vue__ = __webpack_require__("FCYj");
function injectStyle (ssrContext) {
  __webpack_require__("je0H")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e61a1d0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_product_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e61a1d0a_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_product_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "94TT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_models_article_model__ = __webpack_require__("miYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: "NewsPage",
	data: function data() {
		return {
			lang: this.$route.params.lang,
			isReady: false,
			content: [],
			bgImage: null,
			totalPages: null,
			currentPage: 1,
			totalNews: null,
			articleSlug: null,
			article: null,
			url: window.location.href
		};
	},

	props: {},
	created: function created() {
		this.getContent();
		window.addEventListener("mousemove", function () {
			var bg = document.getElementsByClassName('article__bg');
			if (bg && bg[0]) {
				bg[0].style.left = event.pageX - bg[0].offsetWidth / 2 + 'px';
				bg[0].style.top = event.pageY - bg[0].offsetHeight / 2 + 'px';
			}
		});
	},

	watch: {
		"$route": function $route() {
			this.getContent();
			this.getArticle();
			this.url = window.location.href;
		}
	},
	computed: {},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var contentReady = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_1__data_models_article_model__["b" /* getNewsList */])(1).then(function (content) {
					_this.content = content.content;
					_this.totalPages = content.totalPages;
					_this.totalNews = content.totalNews;
					_this.isReady = true;
					resolve(true);
				});
			});
			this.getArticle();

			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([contentReady]).then(function () {
				__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("PAGE_IS_READY", true);
			});
		},
		getMoreContent: function getMoreContent(page) {
			var _this2 = this;

			Object(__WEBPACK_IMPORTED_MODULE_1__data_models_article_model__["b" /* getNewsList */])(1, page).then(function (content) {
				content.content.forEach(function (element) {
					_this2.content.push(element);
				});
				_this2.totalPages = content.totalPages;
				_this2.totalNews = content.totalNews;
				_this2.currentPage++;
			});
		},
		getArticle: function getArticle() {
			var _this3 = this;

			this.articleSlug = this.$route.params.article;
			if (this.articleSlug) {
				Object(__WEBPACK_IMPORTED_MODULE_1__data_models_article_model__["a" /* getArticleEntry */])(this.articleSlug, "slug", 1).then(function (content) {
					_this3.article = content;
				});
			}
		},

		showImage: function showImage(event, value) {
			this.bgImage = value;
		},
		hideImage: function hideImage(value) {
			this.bgImage = null;
		}
	}
});

/***/ }),

/***/ "A7kh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getItemEntry */
/* unused harmony export getItemsList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_connection__ = __webpack_require__("dmZD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__ = __webpack_require__("gm3k");



/**
 * Gets a center entry.
 */
var getItemEntry = function getItemEntry(value, slugOrId) {
	return Object(__WEBPACK_IMPORTED_MODULE_1__data_connection__["a" /* getAction */])("collections", value, slugOrId).then(function (data) {
		if (data.data[0]) return processEntry(data.data[0]);
		if (data.data) return processEntry(data.data);
	});
};

/**
 * Gets a list of centers.
 */
var getItemsList = function getItemsList() {
	return Object(__WEBPACK_IMPORTED_MODULE_1__data_connection__["b" /* listAction */])("collections").then(function (data) {
		return processList(data.data);
	});
};

/**
 * Process Entry.
 */
var processEntry = function processEntry(data) {
	var content = data;

	if (content.better_featured_image) content.better_featured_image = new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](content.better_featured_image);

	if (content.meta_box.gallery) {
		content.meta_box.gallery = content.meta_box.gallery.map(function (image) {
			return new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](image);
		});
	}
	return content;
};

/**
 * Process List.
 */
var processList = function processList(data) {
	var content = data;

	content.map(function (value) {
		processEntry(value);
	});

	return content;
};

/***/ }),

/***/ "AjY1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "TextBlock",
	data: function data() {
		return {
			editedSource: null
		};
	},

	props: ["source"],
	created: function created() {},

	watch: {},
	computed: {},
	mounted: function mounted() {
		this.identifyVideo();
	},

	methods: {
		identifyVideo: function identifyVideo() {
			var videoIni = this.source.indexOf("[embed]");
			var videoEnd = this.source.indexOf("[/embed]");

			var videoTag = this.source.substring(videoIni, videoEnd + 8);
			var videoUrl = this.source.substring(videoIni + 7, videoEnd);

			var template = '<div class="video__wrapper"><iframe class="video" src="' + videoUrl + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>';

			if (videoIni !== -1) {
				this.editedSource = this.source.replace(videoTag, template);
			} else this.editedSource = this.source;
		}
	}
});

/***/ }),

/***/ "Aysp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "FooterBlock",
	data: function data() {
		return {};
	},

	props: {},
	created: function created() {},

	watch: {},
	computed: {},
	methods: {}
});

/***/ }),

/***/ "B8bs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_exhibition_model__ = __webpack_require__("G3E8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_article_model__ = __webpack_require__("miYY");





/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ExhibitionPage",
	data: function data() {
		return {
			isReady: false,
			content: [],
			language: this.$route.params.lang,
			name: this.$route.name,
			openSection: 0,
			url: window.location.href
		};
	},

	props: {},
	created: function created() {
		this.getContent();
		__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("hideTitle", false);
	},

	watch: {
		$route: function $route() {
			this.getContent();
			this.language = this.$route.params.lang;
			this.url = window.location.href;
		}
	},
	computed: {
		pageUrl: function pageUrl() {
			return location.href;
		}
	},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var contentReady = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_2__data_models_exhibition_model__["b" /* getExhibitionEntry */])(_this.$route.params.exhibition, "slug", 4).then(function (content) {
					_this.content = null;
					_this.content = content;
					_this.isReady = true;
					resolve(true);
				});
			});
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([contentReady]).then(function () {
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PAGE_IS_READY", true);
			});
		},
		nextSection: function nextSection() {
			var exhibitionEl = document.getElementById("exhibition");
			exhibitionEl.scroll({
				left: exhibitionEl.offsetWidth / 2 * (this.openSection + 1),
				behavior: 'smooth'
			});
			if (this.openSection < 1) this.openSection = this.openSection + 1;
			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("hideTitle", true);
			}, 300);
		},
		prevSection: function prevSection() {
			var exhibitionEl = document.getElementById("exhibition");
			exhibitionEl.scroll({
				left: exhibitionEl.offsetWidth / 2 * (this.openSection - 1),
				behavior: 'smooth'
			});
			this.openSection = this.openSection - 1;
			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("hideTitle", false);
			}, 100);
		},
		evalScroll: function evalScroll() {
			var element = document.querySelector(".exhibition__content__c");
			var controller = document.querySelector(".exhibition__controls__next");

			if (this.openSection == 0) {
				if (element.scrollTop + window.innerHeight == element.scrollHeight) controller.classList.add("scroll-animation");else controller.classList.remove("scroll-animation");
			}
		}
	}
});

/***/ }),

/***/ "BQq4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_publications_page_js__ = __webpack_require__("DqbU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52bca962_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_publications_page_vue__ = __webpack_require__("maFX");
function injectStyle (ssrContext) {
  __webpack_require__("KaYr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_publications_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52bca962_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_publications_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CIx6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_models_suggestion_model__ = __webpack_require__("fH87");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: "MindWalksPage",
	data: function data() {
		return {
			lang: this.$route.params.lang,
			isReady: false,
			content: [],
			totalPages: null,
			currentPage: 1,
			totalEntries: null,
			suggestion: null,
			suggestionSlug: null
		};
	},

	props: {},
	created: function created() {
		this.getContent();
		this.getSuggestion();
	},

	watch: {
		"$route": function $route() {
			this.getContent();
			this.getSuggestion();
		}
	},
	computed: {},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var contentReady = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_1__data_models_suggestion_model__["b" /* getSuggestionsList */])(1).then(function (content) {
					_this.content = content.content;
					_this.totalPages = content.totalPages;
					_this.totalEntries = content.totalEntries;
					_this.isReady = true;
					resolve(true);
				});
			});
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([contentReady]).then(function () {
				__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("PAGE_IS_READY", true);
			});
		},
		getMoreContent: function getMoreContent(page) {
			var _this2 = this;

			Object(__WEBPACK_IMPORTED_MODULE_1__data_models_suggestion_model__["b" /* getSuggestionsList */])(1, page).then(function (content) {
				content.content.forEach(function (element) {
					_this2.content.push(element);
				});
				_this2.totalPages = content.totalPages;
				_this2.totalEntries = content.totalNews;
				_this2.currentPage++;
			});
		},
		getSuggestion: function getSuggestion() {
			var _this3 = this;

			this.suggestionSlug = this.$route.params.suggestion;
			if (this.suggestionSlug) {
				Object(__WEBPACK_IMPORTED_MODULE_1__data_models_suggestion_model__["a" /* getSuggestionEntry */])(this.suggestionSlug, "slug", 1).then(function (content) {
					_this3.suggestion = content;
				});
			}
		},

		showImage: function showImage(event, value) {
			this.bgImage = value;
		},
		hideImage: function hideImage(value) {
			this.bgImage = null;
		}
	}
});

/***/ }),

/***/ "CKEf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_exhibition_page_js__ = __webpack_require__("B8bs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25aaeacf_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_exhibition_page_vue__ = __webpack_require__("jLGC");
function injectStyle (ssrContext) {
  __webpack_require__("RhBI")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_exhibition_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25aaeacf_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_exhibition_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CPHK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "InputBlock",
	data: function data() {
		return {};
	},

	props: {},
	created: function created() {},

	watch: {},
	computed: {},
	methods: {}
});

/***/ }),

/***/ "Crlh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"document-block"},[_c('h1',{staticClass:"document-block__title type--display_1"},[_vm._v(_vm._s(_vm.title))]),(_vm.description)?_c('h2',{staticClass:"document-block__description type--body"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c('a',{staticClass:"document-block__download",attrs:{"href":_vm.file.url,"download":"download"}},[_c('span',{staticClass:"type--button"},[_vm._v("Download")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DGzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_models_page_model__ = __webpack_require__("yu3g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");



/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ContactsPage",
	data: function data() {
		return {
			content: null,
			isReady: false
		};
	},

	props: {},
	created: function created() {
		__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
		__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PAGE_IS_READY", true);
	},

	watch: {},
	computed: {},
	methods: {}
});

/***/ }),

/***/ "DqbU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_product_model__ = __webpack_require__("k/A9");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ExhibitionPage",
	data: function data() {
		return {
			isReady: false,
			language: this.$route.params.lang,
			name: this.$route.name,
			content: null,
			currentPage: 1,
			totalPages: null,
			totalProducts: null
		};
	},

	props: {},
	created: function created() {
		this.getContent();
	},

	watch: {
		$route: function $route() {
			this.getContent();
			this.language = this.$route.params.lang;
		}
	},
	computed: {},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var contentReady = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_2__data_models_product_model__["b" /* getProductsList */])(1).then(function (content) {
					_this.content = content.content;
					_this.isReady = true;
					_this.totalPages = content.totalPages;
					_this.totalProducts = content.totalProducts;
					resolve(true);
				});
			});
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([contentReady]).then(function () {
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PAGE_IS_READY", true);
			});
		},
		getMoreContent: function getMoreContent(page) {
			var _this2 = this;

			Object(__WEBPACK_IMPORTED_MODULE_2__data_models_product_model__["b" /* getProductsList */])(1, page).then(function (content) {
				content.content.forEach(function (element) {
					_this2.content.push(element);
				});
				_this2.totalPages = content.totalPages;
				_this2.totalProducts = content.totalProducts;
				_this2.currentPage++;
			});
		}
	}
});

/***/ }),

/***/ "DsMD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_contacts_page_js__ = __webpack_require__("rQPl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1038d2cf_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contacts_page_vue__ = __webpack_require__("NitW");
function injectStyle (ssrContext) {
  __webpack_require__("P/mD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1038d2cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_contacts_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1038d2cf_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_contacts_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "E2al":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EMlq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button"},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FCYj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product",class:{ 'black' : _vm.black },style:('--main-color:' + _vm.item.color)},[_c('router-link',{staticClass:"product__link link",attrs:{"to":{ name:'PublicationPage', params: { publication: _vm.item.slug } }}},[(_vm.item.gallery.length || _vm.item.image)?_c('div',{staticClass:"product__image"},[(_vm.item.image)?_c('image-block',{staticClass:"expand",attrs:{"source":_vm.item.image,"wordpress":"true"}}):_vm._e()],1):_vm._e(),_c('h1',{staticClass:"product__title type--display_1",class:{ 'padding' : _vm.padding }},[_vm._v(_vm._s(_vm.item.title))])]),_c('div',{staticClass:"product__content",class:{ 'disabled' : _vm.item.type == 'sold_out', 'padding' : _vm.padding }},[_c('div',{staticClass:"product__content__buy"},[(_vm.item.price)?_c('div',{staticClass:"product__content__buy__price"},[_c('h1',{staticClass:"type--display_1",class:{ 'line-through' : _vm.item.type == 'sold_out' }},[_vm._v(_vm._s(_vm.item.price)+"€")]),(_vm.item.type == 'sold_out')?_c('span',{staticClass:"type--display_1 type--uppercase red"},[_vm._v(_vm._s(_vm.$t('store.soldOut', _vm.language))+"!")]):_vm._e()]):_vm._e(),(_vm.item.url && _vm.item.type != 'sold_out')?_c('a',{staticClass:"product__content__buy__button type--display_1 link",class:{'black' : _vm.black},attrs:{"href":_vm.item.url}},[_vm._v(_vm._s(_vm.$t('store.buy', _vm.language)))]):_vm._e()])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "G3E8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getExhibitionEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getExhibitionsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCurrentExhibitionsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_connection__ = __webpack_require__("dmZD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__ = __webpack_require__("gm3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_article_class__ = __webpack_require__("i/B4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_file_class__ = __webpack_require__("aIMt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_partner_class__ = __webpack_require__("LkvG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__classes_product_class__ = __webpack_require__("71jN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_document_class__ = __webpack_require__("XN52");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__classes_exhibition_class__ = __webpack_require__("uV3G");









/**
 * Gets a center entry.
 */
var getExhibitionEntry = function getExhibitionEntry(value, slugOrId, recursive) {
	return Object(__WEBPACK_IMPORTED_MODULE_1__data_connection__["a" /* getAction */])("exhibitions", value, slugOrId, recursive).then(function (data) {
		if (data.data[0]) return processEntry(data.data[0]);
		if (data.data) return processEntry(data.data);
	});
};

/**
 * Gets a list of centers.
 */
var getExhibitionsList = function getExhibitionsList(recursive, page, perPage) {
	return Object(__WEBPACK_IMPORTED_MODULE_1__data_connection__["b" /* listAction */])("exhibitions", recursive, page, perPage).then(function (data) {

		return { content: processList(data.data), totalExhibitions: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
};

/**
 * Gets Current Exhibition
 */
var getCurrentExhibitionsList = function getCurrentExhibitionsList(recursive) {
	return Object(__WEBPACK_IMPORTED_MODULE_1__data_connection__["b" /* listAction */])("current-exhibitions", recursive).then(function (data) {
		return { content: data.data, totalExhibitions: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
};

/**
 * Process Entry.
 */
var processEntry = function processEntry(data) {
	var content = new __WEBPACK_IMPORTED_MODULE_8__classes_exhibition_class__["a" /* Exhibition */](data);
	// console.log("ExhibitionModel :: processEntry :: content.meta_boc.gallery : ", content.gallery)
	// console.log("ExhibitionModel :: processEntry :: Related_ids : ", data.related_ids)

	// // console.log("Exhibition content:", content)

	if (content.image && data.related_ids[content.image[0]]) content.image = new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](data.related_ids[content.image[0]]);

	if (content.gallery.length && data.related_ids) {
		content.gallery = content.gallery.map(function (id) {
			if (data.related_ids[id]) return new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](data.related_ids[id]);
		});
	}

	if (content.videos.length && data.related_ids) {
		content.videos = content.videos.map(function (id) {
			if (data.related_ids[id]) return new __WEBPACK_IMPORTED_MODULE_4__classes_file_class__["a" /* File */](data.related_ids[id]);
		});
	}

	// Relations
	if (content.news.length && data.related_ids) {
		content.news = content.news.map(function (item) {
			if (data.related_ids[item]) return new __WEBPACK_IMPORTED_MODULE_3__classes_article_class__["a" /* Article */](data.related_ids[item]);
		});
	}

	if (content.products.length && data.related_ids) {
		content.products = content.products.map(function (item) {

			var productData = data.related_ids[item];
			var product = new __WEBPACK_IMPORTED_MODULE_6__classes_product_class__["a" /* Product */](data.related_ids[item]);

			if (productData.related_ids) {
				if (product.image && productData.related_ids[product.image]) product.image = new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](productData.related_ids[product.image]);

				if (product.gallery) {
					product.gallery = product.gallery.map(function (image) {
						if (productData.related_ids[image]) return new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](productData.related_ids[image]);
					});
				}
			}
			return product;
		});
	}

	if (content.documents.length && data.related_ids) {
		content.documents = content.documents.map(function (item) {

			var documentData = data.related_ids[item];
			var document = new __WEBPACK_IMPORTED_MODULE_7__classes_document_class__["a" /* Document */](data.related_ids[item]);

			// console.log("Document", documentData)

			if (documentData.related_ids) {
				if (document.image && documentData.related_ids[document.image]) document.image = new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](documentData.related_ids[document.image]);

				if (document.file && documentData.related_ids[document.file]) document.file = new __WEBPACK_IMPORTED_MODULE_4__classes_file_class__["a" /* File */](documentData.related_ids[document.file]);
			}

			return document;
		});
	}

	if (content.partners && content.partners.length) {
		content.partners = content.partners.map(function (group) {

			group.content = group.content.map(function (partner) {
				if (partner._get_partner && data.related_ids[partner._get_partner]) {

					var partnerData = data.related_ids[partner._get_partner];
					var partnerContent = new __WEBPACK_IMPORTED_MODULE_5__classes_partner_class__["a" /* Partner */](partnerData);

					// console.log("Partner", partnerData.related_ids)

					// console.log("Partner Data: ", partnerData.related_ids[partnerContent.url[0]])
					if (partnerData.related_ids) {
						if (partnerContent && partnerData.related_ids[partnerContent.url[0]]) {
							partnerContent.url = partnerData.related_ids[partnerContent.url[0]].source_url;
						}
					}

					partner = partnerContent;
				}
				return partner;
			});

			return group;
		});
	}
	return content;
};

/**
 * Process List.
 */
var processList = function processList(data) {
	var content = data;

	content = content.map(function (value) {
		return processEntry(value);
	});

	return content;
};

/***/ }),

/***/ "Gxbx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_sidecontent_block_js__ = __webpack_require__("py3E");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f315be_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_sidecontent_block_vue__ = __webpack_require__("RFHG");
function injectStyle (ssrContext) {
  __webpack_require__("6SEG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36f315be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_sidecontent_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f315be_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_sidecontent_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HepC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Suggestion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var Suggestion = function Suggestion(object) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Suggestion);

	// Info
	this.id = object.id || null;
	this.slug = object.slug || null;
	this.title = object.title.rendered || null;
	this.date = object.date || null;
	this.status = object.status || null;

	// Content
	this.author = object.meta_box.author || null;
	this.authorProfession = object.meta_box.profession || null;
	this.image = object.meta_box.image || null;
	this.suggestions = object.meta_box.suggestions || null;
};

/***/ }),

/***/ "IHky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('main',{staticClass:"suggestions-page element-colorize",attrs:{"data-logo-color":'#000'}},[_c('header',{staticClass:"suggestions-page__header"},[_c('div',{staticClass:"suggestions-page__header__title"},[_c('h1',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.$t('pages.suggestions', _vm.lang)))])]),_c('ul',{staticClass:"suggestions-page__list"},_vm._l((_vm.content),function(suggestion){return _c('li',{staticClass:"suggestion"},[_c('router-link',{attrs:{"to":{ name: 'SuggestionsPage', params: { suggestion: suggestion.slug } }}},[_c('time',{staticClass:"suggestion__time type--display_1",class:{ 'inactive' : _vm.suggestionSlug != suggestion.slug && _vm.suggestionSlug }},[_vm._v(_vm._s(_vm._f("date")(suggestion.date,'short', null, ['/', '.'])))]),_c('h1',{staticClass:"suggestion__title type--display_1 link",class:{ 'inactive' : _vm.suggestionSlug != suggestion.slug && _vm.suggestionSlug }},[_vm._v(_vm._s(suggestion.title))])])],1)}),0),_c('nav',{staticClass:"suggestions-page__header__actions"},[_c('h2',{staticClass:"suggestions-page__actions__info type--button type--uppercase"},[_vm._v(_vm._s(_vm.content.length)+"—"+_vm._s(_vm.totalEntries)+" "+_vm._s(_vm.$t('pages.suggestions', _vm.lang)))]),(_vm.totalPages > _vm.currentPage)?_c('button',{staticClass:"link type--button type--uppercase",on:{"click":function($event){return _vm.getMoreContent(_vm.currentPage + 1)}}},[_vm._v(_vm._s(_vm.$t('buttons.more', _vm.lang )))]):_vm._e()])]),(_vm.suggestion)?_c('article',{key:_vm.suggestion.slug,staticClass:"suggestions-page__suggestion"},[_c('time',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm._f("date")(_vm.suggestion.date,'short', null, ['/', '.'])))]),_c('h1',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.suggestion.title))]),_c('h2',{staticClass:"type--display_1",domProps:{"innerHTML":_vm._s(_vm.suggestion.authorProfession)}}),_c('div',{staticClass:"suggestions-page__suggestion__image"},[(_vm.suggestion.image)?_c('image-block',{staticClass:"expand",attrs:{"source":_vm.suggestion.image,"wordpress":"true"}}):_vm._e()],1),_c('dl',{staticClass:"suggestions-page__suggestion__content"},[_vm._l((_vm.suggestion.suggestions),function(type){return [_c('dt',{staticClass:"type--display_1 type--italic",domProps:{"innerHTML":_vm._s(type.header)}}),_c('dd',[_c('text-block',{staticClass:"type--display_1",attrs:{"source":type.suggestion_full}})],1)]})],2)]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Icai":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/img_store-01.6558c60.jpg";

/***/ }),

/***/ "J4l9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "J9Ry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__("NHnr");


/* harmony default export */ __webpack_exports__["a"] = ({
	name: "LoadingBlock",
	data: function data() {
		return {
			error: false
		};
	},

	props: {},
	created: function created() {
		var _this = this;

		__WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on("apiError", function (error) {
			console.error("ERROR:", error);
			_this.error = true;
		});
	},

	watch: {},
	computed: {},
	mounted: function mounted() {},

	methods: {}
});

/***/ }),

/***/ "JL6g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_page_js__ = __webpack_require__("gdaP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73bd464f_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_home_page_vue__ = __webpack_require__("vURb");
function injectStyle (ssrContext) {
  __webpack_require__("a13Z")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_home_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73bd464f_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_home_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JRWW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ButtonBlock",
	data: function data() {
		return {};
	},

	props: {
		title: String
	},
	created: function created() {},

	watch: {},
	computed: {},
	methods: {}
});

/***/ }),

/***/ "JsOn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_block_js__ = __webpack_require__("Aysp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d4c7f7b_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_footer_block_vue__ = __webpack_require__("J4l9");
function injectStyle (ssrContext) {
  __webpack_require__("oM49")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d4c7f7b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_footer_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d4c7f7b_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_footer_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KaYr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LkvG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Partner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var Partner = function Partner(object) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Partner);

	// console.log("Partner", object)

	// Info
	this.id = object.id || null;
	this.slug = object.slug || null;
	this.title = object.title.rendered || null;
	this.date = object.date || null;

	// Content
	this.websiteUrl = object.meta_box.content.website_url || null;
	this.url = object.meta_box.content._get_file || null;
};

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_App_js__ = __webpack_require__("78FQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e795e3e_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("mPh3");
function injectStyle (ssrContext) {
  __webpack_require__("tk8Q")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_App_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2e795e3e_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i18n", function() { return i18n; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("cHtD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_helpers_date_pipe_js__ = __webpack_require__("x/kf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_helpers_date_cdd_js__ = __webpack_require__("3Eyw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_helpers_strip_html_js__ = __webpack_require__("w+BA");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import * as connection from "@/data/connection"
// import * as lodash from "lodash"
// import Modernizr from "modernizr"



/**
 * Vue configuration.
 */
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].set(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, "$lodash", __webpack_require__("M4fF"));

// ===================
// 	Blocks
// ===================

__webpack_require__("zNeH");

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_carousel___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]);

// ===================
// 	Translations
// ===================

var messages = __webpack_require__("h8Jo");

var i18n = new __WEBPACK_IMPORTED_MODULE_4_vue_i18n__["a" /* default */]({
	locale: 'en',
	messages: messages
});

// ===================
// 	Helpers
// ===================





// ===================
//  Filters
// ===================

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("date", __WEBPACK_IMPORTED_MODULE_6__data_helpers_date_cdd_js__["a" /* dateCdd */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("datePipe", __WEBPACK_IMPORTED_MODULE_5__data_helpers_date_pipe_js__["a" /* transform */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].filter("stripHtml", __WEBPACK_IMPORTED_MODULE_7__data_helpers_strip_html_js__["a" /* stripHtml */]);

// Global event bus.
var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]();
/**
 * Vue Initialization.
 */
/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: "#app",
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	template: "<App/>",
	components: { App: __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */] },
	i18n: i18n
});

// Vue.prototype.$moderznir = Modernizr;
// console.log(Vue.prototype._.find())

/***/ }),

/***/ "NitW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('section',{staticClass:"contacts element-colorize",attrs:{"data-logo-color":"#fff"}},[_c('div',{staticClass:"contacts__title"},[_c('h1',{staticClass:"type--display_3"},[_vm._v(_vm._s(_vm.content.title.rendered))])]),_c('div',{staticClass:"contacts__content"},[_c('div',{staticClass:"contacts__content__text type--body",domProps:{"innerHTML":_vm._s(_vm.content.content.rendered)}}),_c('dl',{staticClass:"contacts__content__side"},[_vm._l((_vm.content.meta_box.contact),function(item){return [_c('dt',{staticClass:"type--headline type--uppercase"},[_vm._v(_vm._s(item.title))]),_c('dd',{staticClass:"type--display_3"},[_vm._v(_vm._s(item.value))])]})],2)])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NlmE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ButtonBlock",
	data: function data() {
		return {
			isOpen: false,
			language: this.$route.params.lang
		};
	},

	props: ["item", "index", "black", "padding"],
	created: function created() {},

	watch: {
		"$route": function $route() {
			this.language = this.$route.params.lang;
		}
	},
	computed: {},
	methods: {
		toggleObject: function toggleObject() {
			this.isOpen = !this.isOpen;
		}
	}
});

/***/ }),

/***/ "NoJm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ButtonBlock",
	data: function data() {
		return {
			isOpen: false,
			language: this.$route.params.lang
		};
	},

	props: ["item", "index", "black"],
	created: function created() {},

	watch: {
		"$route": function $route() {
			this.language = this.$route.params.lang;
		}
	},
	computed: {},
	methods: {
		toggleObject: function toggleObject() {
			this.isOpen = !this.isOpen;
		}
	}
});

/***/ }),

/***/ "ODQc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_block_js__ = __webpack_require__("CPHK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b412141e_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_input_block_vue__ = __webpack_require__("guVY");
function injectStyle (ssrContext) {
  __webpack_require__("E2al")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b412141e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_input_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b412141e_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_input_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OkAp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_product_model__ = __webpack_require__("k/A9");




// import { getArticleEntry } from "../../../data/models/article.model";
// import pdf from "pdfvuer";


/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ExhibitionPage",
	components: {},
	data: function data() {
		return {
			isReady: false,
			content: [],
			pageLeft: 0,
			pageRight: 1,
			openSection: 0,
			activeSection: "general",
			language: this.$route.params.lang,
			url: window.location.href
		};
	},

	props: {},
	created: function created() {
		this.getContent();
		__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("hideTitle", true);
	},
	mounted: function mounted() {},

	watch: {
		$route: function $route() {
			this.getContent();
			this.language = this.$route.params.lang;
			this.url = window.location.href;
		}
	},
	computed: {
		pageUrl: function pageUrl() {
			return location.href;
		}
	},
	methods: {
		getContent: function getContent() {
			var _this = this;

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
				return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
					while (1) {
						switch (_context.prev = _context.next) {
							case 0:
								_context.next = 2;
								return new __WEBPACK_IMPORTED_MODULE_3__data_models_product_model__["a" /* getProductEntry */](_this.$route.params.publication, "slug", 1);

							case 2:
								_this.content = _context.sent;

								_this.isReady = true;
								setTimeout(function () {
									var page = document.getElementById("publication-page");
									if (page) {
										page.addEventListener("scroll", function () {
											_this.evalScroll();
										});
									}
								}, 200);

							case 5:
							case "end":
								return _context.stop();
						}
					}
				}, _callee, _this);
			}))();
		},
		nextPage: function nextPage() {
			this.pageLeft = this.pageLeft + 2;
			this.pageRight = this.pageRight + 2;
		},
		prevPage: function prevPage() {
			this.pageLeft = this.pageLeft - 2;
			this.pageRight = this.pageRight - 2;
		},
		scrollTo: function scrollTo(id) {
			var el = document.getElementById(id);
			var page = document.getElementById("publication-page");
			page.scroll({
				top: 0,
				left: el.offsetLeft,
				behavior: "smooth"
			});
		},
		evalScroll: function evalScroll(id) {
			var page = document.getElementById("publication-page");
			var elIds = ["general", "viewer", "credits"];

			for (var i = 0; i < elIds.length; i++) {
				var _id = elIds[i];
				var el = document.getElementById(_id);

				if (page.scrollLeft + el.offsetLeft / 2 > el.offsetLeft && page.scrollLeft < el.offsetLeft + el.offsetWidth / 2) {
					this.activeSection = _id;
				}
			}
		},
		getPageLeft: function getPageLeft() {
			if (this.pageLeft > 0) {
				return this.pageLeft;
			} else {
				return 2;
			}
		}
	}
});

/***/ }),

/***/ "OxS7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_block_js__ = __webpack_require__("sb3R");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643bbb3b_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_header_block_vue__ = __webpack_require__("ZF5T");
function injectStyle (ssrContext) {
  __webpack_require__("VyEb")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-643bbb3b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_header_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_643bbb3b_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_header_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "P/mD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PZFy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_exhibition_model__ = __webpack_require__("G3E8");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ArchiivePage",
	data: function data() {
		return {
			language: this.$route.params.lang,
			exhibitionsIsReady: false,
			contentIsReady: false,
			exhibitions: [],
			bgImage: false,
			currentArea: null,
			currentPage: 1,
			totalPages: null,
			totalExhibitions: null
		};
	},

	props: {},
	created: function created() {
		this.getContent();
		window.addEventListener("mousemove", function () {
			var bg = document.getElementsByClassName('archive__bg');
			if (bg && bg[0]) {
				bg[0].style.left = event.pageX - bg[0].offsetWidth / 2 + 'px';
				bg[0].style.top = event.pageY - bg[0].offsetHeight / 2 + 'px';
			}
		});
	},

	watch: {
		$route: function $route() {
			this.getContent();
		}
	},
	computed: {},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var exhibitionsList = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_2__data_models_exhibition_model__["c" /* getExhibitionsList */])(2).then(function (content) {
					_this.exhibitions = content.content;
					_this.totalPages = content.totalPages;
					_this.totalExhibitions = content.totalExhibitions;
					_this.exhibitionsIsReady = true;
					resolve(true);
				});
			});
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([exhibitionsList]).then(function () {
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PAGE_IS_READY", true);
			});
		},
		getMoreContent: function getMoreContent(page) {
			var _this2 = this;

			Object(__WEBPACK_IMPORTED_MODULE_2__data_models_exhibition_model__["c" /* getExhibitionsList */])(1, page).then(function (content) {
				content.content.forEach(function (element) {
					_this2.exhibitions.push(element);
				});
				_this2.totalPages = content.totalPages;
				_this2.totalExhibitions = content.totalExhibitions;
				_this2.currentPage++;
			});
		},

		showImage: function showImage(event, value) {
			this.bgImage = value;
		},
		hideImage: function hideImage(value) {
			this.bgImage = null;
		}
		// skewOnScroll: function () {
		// 	const articles = document.getElementsByClassName("archive__content__item")
		// 	let currentPixel = window.pageYOffset

		// 	const looper = function () {
		// 		const newPixel = window.pageYOffset;
		// 		const diff = newPixel - currentPixel;
		// 		const speed = diff * 0.8

		// 		for ( let i = 0; i < articles.length; i++ ) {
		// 			articles[i].style.transform = "skewY(" + speed +"deg)"
		// 		}
		// 		currentPixel = newPixel;
		// 		requestAnimationFrame(looper);
		// 	}
		// 	looper();
		// },
	}
});

/***/ }),

/***/ "QkVt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

// see vue-loader.conf
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['src']
});

/***/ }),

/***/ "QyyU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RFHG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"side-content element-colorize",class:{ 'open' : _vm.index -1 < _vm.openIndex, 'last' : _vm.last,   },style:('--bg-color: ' + _vm.color + '; --color: ' + _vm.dataColor + '; --index: ' + _vm.index),attrs:{"data-logo-color":_vm.dataColor}},[_c('h2',{staticClass:"side-content__title type--display_1"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RhBI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SLTj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_block_js__ = __webpack_require__("JRWW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68952f9b_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_button_block_vue__ = __webpack_require__("EMlq");
function injectStyle (ssrContext) {
  __webpack_require__("f/Fq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68952f9b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_button_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68952f9b_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_button_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TOgF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VyEb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WNyC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_publication_page_js__ = __webpack_require__("OkAp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9ee115_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_publication_page_vue__ = __webpack_require__("+vI6");
function injectStyle (ssrContext) {
  __webpack_require__("YDxe")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_publication_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d9ee115_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_publication_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wsat":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XN52":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Document; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var Document = function Document(object) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Document);

	// Info
	this.id = object.id || null;
	this.slug = object.slug || null;
	this.title = object.title.rendered || null;
	this.date = object.date || null;

	// Content
	this.content = object.meta_box.content.content || null;
	this.file = object.meta_box.content.file || null;

	// Image
	this.image = object.meta_box.content.image || null;

	// Relations
	this.exhibitions = object.meta_box.news_to_exhibitions_to || [];
};

/***/ }),

/***/ "YDxe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Yrn1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slideshow-block"},[_c('div',{staticClass:"slideshow-block__gallery",class:_vm.type,on:{"scroll":function($event){return _vm.evalScroll($event)}}},[_vm._t("default")],2),(_vm.items.length > 1)?_c('div',{staticClass:"slideshow-block__slick",class:_vm.type},_vm._l((_vm.items),function(item,index){return _c('button',{staticClass:"button",on:{"click":function($event){return _vm.scrollMove($event, index)}}},[_c('div',{staticClass:"button__el",class:{ 'active' : _vm.activeIndex === index },style:('background-color: ' + _vm.color),on:{"click":function($event){return _vm.scrollMove($event, index, true)}}})])}),0):_vm._e(),(_vm.activeIndex > 0)?_c('div',{staticClass:"slideshow-block__target prev",on:{"click":function($event){return _vm.scrollMove($event, _vm.activeIndex - 1)}}}):_vm._e(),(_vm.activeIndex < _vm.items.length)?_c('div',{staticClass:"slideshow-block__target next",on:{"click":function($event){return _vm.scrollMove($event, _vm.activeIndex + 1)}}}):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Z1Rj":
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 54 54\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Artboard\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"logo\" transform=\"translate(1.000000, 1.000000)\"><path d=\"M33.5,47.5 L33.5,18.5 L19,18.5 C10.9918711,18.5 4.5,24.9918711 4.5,33 C4.5,41.0081289 10.9918711,47.5 19,47.5 L33.5,47.5 Z\" id=\"Rectangle-Copy-2\"></path><path d=\"M0.1118305,52.0448518 L52.0448518,0.1118305\" id=\"Path-3\"></path><path d=\"M18.5,4.5 L18.5,33.5 L33,33.5 C41.0081289,33.5 47.5,27.0081289 47.5,19 C47.5,10.9918711 41.0081289,4.5 33,4.5 L18.5,4.5 Z\" id=\"Rectangle-Copy\"></path></g></g></svg>"

/***/ }),

/***/ "ZF5T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('header',{staticClass:"header-block",class:{'open' : _vm.menuIsActive}},[_c('nav',{staticClass:"header-block__nav element-colorize",class:{'open' : _vm.menuIsActive}},[_c('router-link',{staticClass:"header-block__nav__logo",class:{'open' : _vm.menuIsActive},attrs:{"to":{ name: 'HomePage' }}},[_c('vector',{staticClass:"header-block__nav__logo__vector",attrs:{"src":__webpack_require__("Z1Rj")}})],1),_c('button',{staticClass:"header-block__nav__menu",on:{"click":function($event){return _vm.toggleMenu()},"mouseover":function($event){return _vm.menuHover(true);},"mouseleave":function($event){return _vm.menuHover(false);}}},[(!_vm.menuIsActive)?_c('span',{staticClass:"header-block__nav__menu__text type--button link"},[_vm._v(_vm._s('MENU'))]):_c('span',{staticClass:"header-block__nav__menu__text type--button link"},[_vm._v(_vm._s('FECHAR'))])])],1),_c('section',{staticClass:"header-block__modal u-scroll-bar element-colorize",class:{'open' : _vm.menuIsActive },attrs:{"data-logo-color":'#000'}},[_c('div',{staticClass:"header-block__modal__container"},[_c('router-link',{staticClass:"header-block__modal__container__link type--display_2 link",attrs:{"to":{name: 'NewsPage'}}},[_vm._v(_vm._s(_vm.$t('pages.news', _vm.language)))]),_c('router-link',{staticClass:"header-block__modal__container__link type--display_2 link",attrs:{"to":{name: 'AboutPage'}}},[_vm._v(_vm._s(_vm.$t('pages.about', _vm.language)))]),_c('router-link',{staticClass:"header-block__modal__container__link type--display_2 link",attrs:{"to":{name: 'ArchivePage'}}},[_vm._v(_vm._s(_vm.$t('pages.exhibitions', _vm.language)))]),_c('router-link',{staticClass:"header-block__modal__container__link type--display_2 link",attrs:{"to":{name: 'PublicationsPage'}}},[_vm._v(_vm._s(_vm.$t('pages.store', _vm.language)))])],1),(_vm.content.meta_box.contact.length)?_c('div',{staticClass:"header-block__modal__container grow"},[_c('dl',{staticClass:"header-block__contacts"},[_vm._l((_vm.content.meta_box.contact),function(contact){return [_c('dt',{staticClass:"type--body"},[_vm._v(_vm._s(contact.title))]),_c('dd',{staticClass:"type--body"},[_vm._v(_vm._s(contact.value))])]})],2),_vm._m(0)]):_vm._e(),_c('div',{staticClass:"header-block__modal__footer"},[_c('div',{staticClass:"header-block__modal__footer__actions"},[(_vm.language == 'en' && !_vm.newsletterOpen)?_c('router-link',{attrs:{"to":{ name: _vm.name, params: { lang: 'pt' } }}},[_c('span',{staticClass:"type--button type--uppercase link"},[_vm._v("Português")])]):_vm._e(),(_vm.language == 'pt' && !_vm.newsletterOpen)?_c('router-link',{attrs:{"to":{ name: _vm.name, params: { lang: 'en' } }}},[_c('span',{staticClass:"type--button type--uppercase link"},[_vm._v("English")])]):_vm._e(),(!_vm.newsletterOpen)?_c('button',{staticClass:"type--button type--uppercase link",on:{"click":function($event){_vm.newsletterOpen = !_vm.newsletterOpen}}},[_vm._v("Newsletter")]):_vm._e(),(_vm.newsletterOpen)?_c('aside',{staticClass:"header-block__modal__subscribe",attrs:{"id":"mc_embed_signup"}},[_c('form',{staticClass:"validate",attrs:{"id":"mc-embedded-subscribe-form","action":"https://esad.us9.list-manage.com/subscribe/post?u=742b1450fd1424a151e71d5a4&amp;id=2af19080f2","method":"post","name":"mc-embedded-subscribe-form","target":"_blank","novalidate":""}},[_c('div',{attrs:{"id":"mc_embed_signup_scroll"}},[_vm._m(1),_vm._m(2),_vm._m(3),_c('div',{staticClass:"clear"},[_c('button',{staticClass:"button type--caption link",on:{"click":function($event){_vm.newsletterOpen = false}}},[_vm._v("Cancelar")]),_c('input',{staticClass:"button type--button type--uppercase link",attrs:{"id":"mc-embedded-subscribe","type":"submit","value":"Subscrever","name":"subscribe"}})])])])]):_vm._e()],1),_c('div',{staticClass:"header-block__modal__footer__partners"},[_c('a',{staticClass:"partner",attrs:{"href":"http://www.cm-matosinhos.pt/"}},[_c('vector',{attrs:{"src":__webpack_require__("exiJ")}})],1),_c('a',{staticClass:"partner",attrs:{"href":"https://esadidea.pt/"}},[_c('vector',{attrs:{"src":__webpack_require__("mTW9")}})],1)])])])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"header-block__social"},[_c('li',[_c('a',{attrs:{"href":"https://www.facebook.com/Casa-do-Design-571323936656125"}},[_vm._v("Facebook")])]),_c('li',[_c('a',{attrs:{"href":"http://instagram.com/casa.do.design"}},[_vm._v("Instagram")])]),_c('li',[_c('a',{attrs:{"href":"https://www.youtube.com/channel/UCWSqb-BjPGu5shiR9w-8Ipw"}},[_vm._v("Youtube")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mc-field-group"},[_c('label',{staticClass:"type--caption type--mono",attrs:{"for":"mce-EMAIL"}},[_vm._v("Email"),_c('span',{staticClass:"asterisk"})]),_c('input',{staticClass:"required email type--body",attrs:{"id":"mce-EMAIL","type":"email","value":"","name":"EMAIL"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clear",attrs:{"id":"mce-responses"}},[_c('div',{staticClass:"response",staticStyle:{"display":"none"},attrs:{"id":"mce-error-response"}}),_c('div',{staticClass:"response",staticStyle:{"display":"none"},attrs:{"id":"mce-success-response"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","left":"-5000px"},attrs:{"aria-hidden":"true"}},[_c('input',{attrs:{"type":"text","name":"b_e6846e0e48b6a09f09229ad36_ad238c803b","tabindex":"-1","value":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a13Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a68k":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aIMt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return File; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var File = function File(object) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, File);

	// Info
	this.id = object.id || null;
	this.slug = object.slug || null;
	this.title = object.title.rendered || null;
	this.date = object.date || null;
	this.media = object.media_type || null;
	this.caption = object.caption.rendered || null;

	// Content
	this.url = object.source_url || null;
};

/***/ }),

/***/ "aNx+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "azah":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cHtD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_home_home_page_vue__ = __webpack_require__("JL6g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_news_news_page_vue__ = __webpack_require__("tpo5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_suggestions_suggestions_page_vue__ = __webpack_require__("1te6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_article_article_page_vue__ = __webpack_require__("f/8b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_contacts_contacts_page_vue__ = __webpack_require__("DsMD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_about_about_page_vue__ = __webpack_require__("nZh1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_exhibition_exhibition_page_vue__ = __webpack_require__("CKEf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_publication_publication_page_vue__ = __webpack_require__("WNyC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_pages_archive_archive_page_vue__ = __webpack_require__("/xNW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_pages_publications_publications_page_vue__ = __webpack_require__("BQq4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_pages_error_error_page_vue__ = __webpack_require__("drh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_playground_playground_page_vue__ = __webpack_require__("/Kbq");

















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	mode: "history",
	routes: [{
		path: "/",
		redirect: "/pt"
	}, {
		path: "/:lang",
		component: __WEBPACK_IMPORTED_MODULE_2__components_pages_home_home_page_vue__["a" /* default */],
		name: "HomePage"
	}, {
		path: "/:lang/about",
		component: __WEBPACK_IMPORTED_MODULE_7__components_pages_about_about_page_vue__["a" /* default */],
		name: "AboutPage"
	}, {
		path: "/:lang/suggestions",
		component: __WEBPACK_IMPORTED_MODULE_4__components_pages_suggestions_suggestions_page_vue__["a" /* default */],
		name: "SuggestionsPage",
		children: [{
			path: "/:lang/suggestions/:suggestion",
			component: __WEBPACK_IMPORTED_MODULE_4__components_pages_suggestions_suggestions_page_vue__["a" /* default */],
			name: "SuggestionsPage"
		}]
	}, {
		path: "/:lang/news",
		component: __WEBPACK_IMPORTED_MODULE_3__components_pages_news_news_page_vue__["a" /* default */],
		name: "NewsPage",
		children: [{
			path: "/:lang/news/:article",
			component: __WEBPACK_IMPORTED_MODULE_3__components_pages_news_news_page_vue__["a" /* default */],
			name: "NewsPage"
		}]
	}, {
		path: "/:lang/exhibitions/:exhibition",
		component: __WEBPACK_IMPORTED_MODULE_8__components_pages_exhibition_exhibition_page_vue__["a" /* default */],
		name: "ExhibitionPage"
	}, {
		path: "/:lang/publications",
		component: __WEBPACK_IMPORTED_MODULE_11__components_pages_publications_publications_page_vue__["a" /* default */],
		name: "PublicationsPage"
	}, {
		path: "/:lang/publications/:publication",
		component: __WEBPACK_IMPORTED_MODULE_9__components_pages_publication_publication_page_vue__["a" /* default */],
		name: "PublicationPage"
	}, {
		path: "/:lang/archive",
		component: __WEBPACK_IMPORTED_MODULE_10__components_pages_archive_archive_page_vue__["a" /* default */],
		name: "ArchivePage"
	}, {
		path: "/:lang/**",
		component: __WEBPACK_IMPORTED_MODULE_12__components_pages_error_error_page_vue__["a" /* default */],
		name: "ErrorPage"
	}]
}));

/***/ }),

/***/ "cT6L":
/***/ (function(module, exports) {

module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 54 54\"><title>full</title><polyline points=\"3 19 3 3 19 3\" style=\"fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:6px\"></polyline><polyline points=\"35 3 51 3 51 19\" style=\"fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:6px\"></polyline><polyline points=\"51 35 51 51 35 51\" style=\"fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:6px\"></polyline><polyline points=\"19 51 3 51 3 35\" style=\"fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:6px\"></polyline></svg>"

/***/ }),

/***/ "cgbk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_block_js__ = __webpack_require__("n8ch");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a3fffb_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_document_block_vue__ = __webpack_require__("Crlh");
function injectStyle (ssrContext) {
  __webpack_require__("x0lU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55a3fffb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_document_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55a3fffb_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_document_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "czBM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_models_article_model__ = __webpack_require__("miYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_exhibition_model__ = __webpack_require__("G3E8");





/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ArticlePage",
	data: function data() {
		return {
			content: [],
			related: [],
			isReady: false,
			openSection: 0,
			language: this.$route.params.lang,
			url: this.$route.url
		};
	},

	props: {},
	created: function created() {
		this.getContent();
	},

	watch: {
		"$route": function $route() {
			this.language = this.$route.params.lang;
			this.getContent();
		}
	},
	computed: {
		pageUrl: function pageUrl() {
			return location.href;
		}
	},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var contentReady = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_2__data_models_article_model__["a" /* getArticleEntry */])(_this.$route.params.article, 'slug', 2).then(function (content) {
					_this.content = content;
					_this.isReady = true;
					resolve(true);
				});
			});
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([contentReady]).then(function () {
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("PAGE_IS_READY", true);
			});
		},
		nextSection: function nextSection() {
			if (this.openSection < 1) this.openSection = this.openSection + 1;
			console.log("Open Section:", this.openSection);
			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("hideTitle", true);
			}, 300);
		},
		prevSection: function prevSection() {
			this.openSection = this.openSection - 1;
			setTimeout(function () {
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("evalColors", true);
				__WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit("hideTitle", false);
			}, 100);
		},
		evalScroll: function evalScroll() {
			var element = document.querySelector(".page__content__c");
			var controller = document.querySelector(".page__controls__next");

			if (this.openSection == 0 && element) {
				if (element.scrollTop + window.innerHeight == element.scrollHeight) controller.classList.add("scroll-animation");else controller.classList.remove("scroll-animation");
			}
		}
	}
});

/***/ }),

/***/ "dmZD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAction; });
/* unused harmony export createAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return listAction; });
/* unused harmony export customAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main_js__ = __webpack_require__("NHnr");



// const developmentUrl = "http://localhost:4065/wp-json/wp/v2";
var productionUrl = "https://cms.casa-design.pt/wp-json/wp/v2";

var developmentUrl = "https://cms.casa-design.pt/wp-json/wp/v2";

var username = "frontend";
var password = "4Z8X2kjHh4LuEsN6KE2EkV4bts48F9";
var hash = btoa(username + ":" + password);

var API = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
	baseURL:  false ? developmentUrl : productionUrl,
	headers: {
		"Content-Type": "application/json",
		"Authorization": "Basic " + hash
	}
});

/**
 * Gets Params.
 */
var getParams = function getParams(params) {
	var pathname = window.location.pathname;
	var response = { params: {} };

	if (pathname.includes('/pt', 0)) response.params["lang"] = 'pt';else if (pathname.includes('/en', 0)) response.params["lang"] = 'en';

	if (params) {
		params.forEach(function (param) {
			if (param.value) response.params[param.key] = param.value;
		});
	}

	return response;
};

/**
 * Gets a entry.
 */
var getAction = function getAction(cpt, value, slugOrId, recursive) {
	var type = slugOrId ? slugOrId : Number(value) === NaN ? 'slug' : 'id';
	if (type == 'slug') {
		return API.get("/" + cpt + "/?" + type + "=" + value, getParams([{ key: "related_recursive_calls", value: recursive }])).catch(function (error) {
			__WEBPACK_IMPORTED_MODULE_1__main_js__["bus"].$emit("apiError", error);
		});
	}
	if (type == 'id') {
		return API.get("/" + cpt + "/" + value, getParams([{ key: "related_recursive_calls", value: recursive }])).catch(function (error) {
			__WEBPACK_IMPORTED_MODULE_1__main_js__["bus"].$emit("apiError", error);
		});
	}
};

/**
 * Posts a entry.
 */
var createAction = function createAction(cpt, body) {
	return API.post("/" + cpt, body);
};

/**
 * Gets a list (of entries).
 */
var listAction = function listAction(cpt, recursive, page, perPage) {
	return API.get("/" + cpt + "/", getParams([{ key: "related_recursive_calls", value: recursive }, { key: "page", value: page }, { key: "per_page", value: perPage }])).catch(function (error) {
		__WEBPACK_IMPORTED_MODULE_1__main_js__["bus"].$emit("apiError", error);
	});
};

/**
 * Gets an entry or list.
 */
var customAction = function customAction(action) {
	return API.get("/" + action);
};

/***/ }),

/***/ "drh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_error_page_js__ = __webpack_require__("DGzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3f8dc6_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_error_page_vue__ = __webpack_require__("rQ6Y");
function injectStyle (ssrContext) {
  __webpack_require__("6HzD")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a3f8dc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_error_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3f8dc6_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_error_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "exiJ":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns:sketch=\"http://www.bohemiancoding.com/sketch/ns\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 582 104\" style=\"enable-background:new 0 0 582 104;\" xml:space=\"preserve\"><g id=\"Group\" sketch:type=\"MSLayerGroup\"><path id=\"Shape\" sketch:type=\"MSShapeGroup\" d=\"M179.5,52.5l-18.9,42c-2.5,5.7-8.1,9-13.9,9c-5.8,0-11.4-3.3-13.9-9l-18.9-42 L95,94.5c-2.5,5.7-8.1,9-13.9,9s-11.4-3.3-13.9-9l-18.9-42l-18.9,42c-3.4,7.7-12.5,11.1-20.1,7.6S-1.7,89.6,1.7,82L34,10.2 c1.3-3.8,4.2-7,8.1-8.8c2-0.9,4.2-1.3,6.3-1.3s4.2,0.4,6.3,1.3c3.9,1.8,6.8,5,8.1,8.8l18.4,41l18.4-41c1.3-3.8,4.2-7,8.1-8.8 c2-0.9,4.2-1.3,6.3-1.3c2.1,0,4.2,0.4,6.3,1.3c3.9,1.8,6.8,5,8.1,8.8l18.4,41l18.4-41c1.3-3.8,4.2-7,8.1-8.8c2-0.9,4.2-1.3,6.3-1.3 s4.2,0.4,6.3,1.3c3.9,1.8,6.8,5,8.1,8.8L226.1,82c3.4,7.7,0,16.7-7.6,20.1c-7.7,3.4-16.7,0-20.1-7.6L179.5,52.5L179.5,52.5z\"></path><path id=\"Fill-8\" sketch:type=\"MSShapeGroup\" d=\"M275.7,69.2h-8.4v30.2h9.1V80.6c0,0,2.1-4.1,6-4.1c3,0,4.8,1.9,4.8,6.2v16.8h9.1 V80.6c0,0,2.1-4.1,6-4.1c3,0,4.8,1.9,4.8,6.2v16.8h9.1V82.6c0-8.7-3.4-13.6-10.9-13.6c-5.7,0-9,3.7-10.4,5.7 c-1.6-3.7-4.8-5.7-9.5-5.7c-4.6,0-7.7,2.4-9.5,4.5L275.7,69.2L275.7,69.2z M351.8,99.4V69.2H344l-0.4,3c-2.2-2.1-5.1-3.6-8.9-3.6 c-7.9,0-14.2,6.2-14.2,15.7s6.3,15.7,14.2,15.7c3.8,0,6.8-1.4,8.9-3.6l0.4,3L351.8,99.4L351.8,99.4z M343.3,84.3 c0,4.9-2.4,8.1-6.9,8.1s-6.9-3.2-6.9-8.1s2.4-8.1,6.9-8.1S343.3,79.4,343.3,84.3L343.3,84.3L343.3,84.3z M375.4,76.2v-6.9h-5.7V60 l-9.1,2.2v7.1h-4.4v6.9h4.4v15.4c0,5.2,3,8.4,8,8.4c3.6,0,6.9-1.1,6.9-1.1v-7c0,0-1.9,0.5-3.3,0.5c-1.6,0-2.6-0.9-2.6-3.6V76.2 H375.4L375.4,76.2z M379.2,84.3c0,9.5,6.5,15.7,16,15.7s16-6.2,16-15.7s-6.5-15.7-16-15.7C385.7,68.6,379.2,74.8,379.2,84.3 L379.2,84.3L379.2,84.3z M388.3,84.3c0-4.9,2.4-8.1,6.9-8.1s6.9,3.2,6.9,8.1s-2.4,8.1-6.9,8.1C390.7,92.4,388.3,89.2,388.3,84.3 L388.3,84.3L388.3,84.3z M425,92.7c-3.4,0-7.5-3.2-7.5-3.2l-4.2,5.9c0,0,4.6,4.6,11.7,4.6c6.8,0,11.3-3.4,11.3-9.7 c0-9.4-12.8-9.4-12.8-12.9c0-1.1,0.9-1.9,2.4-1.9c3,0,5.4,2.4,5.4,2.4l4.6-5.4c0,0-3.7-3.9-10.3-3.9c-6.4,0-10.8,3.6-10.8,8.8 c0,9.7,13.1,9.4,13.1,13.2C427.8,91.8,426.8,92.7,425,92.7L425,92.7L425,92.7z M450.7,69.2h-9.1v30.2h9.1V69.2L450.7,69.2z M441.1,60.4c0,3.1,2.1,5.1,5.1,5.1c3.1,0,5.1-2.1,5.1-5.1c0-3.1-2.1-5.1-5.1-5.1C443.1,55.3,441.1,57.3,441.1,60.4L441.1,60.4 L441.1,60.4z M466.4,80.6c0,0,2.1-4.1,6-4.1c3,0,4.8,1.9,4.8,6.2v16.8h9.1V82.6c0-8.7-3.4-13.6-10.9-13.6c-4.6,0-7.7,2.4-9.5,4.5 l-0.2-4.2h-8.4v30.2h9.1V80.6L466.4,80.6z M500.8,80.6c0,0,2.1-4.1,6-4.1c3,0,4.8,1.9,4.8,6.2v16.8h9.1V82.6 c0-8.7-3.4-13.6-10.9-13.6c-4.3,0-7.2,2.1-9.1,4V57.1h-9.1v42.3h9.1V80.6H500.8z M524.9,84.3c0,9.5,6.5,15.7,16,15.7 s16-6.2,16-15.7s-6.5-15.7-16-15.7C531.4,68.6,524.9,74.8,524.9,84.3L524.9,84.3L524.9,84.3z M534,84.3c0-4.9,2.4-8.1,6.9-8.1 s6.9,3.2,6.9,8.1s-2.4,8.1-6.9,8.1S534,89.2,534,84.3L534,84.3L534,84.3z M570.7,92.7c-3.4,0-7.5-3.2-7.5-3.2l-4.2,5.9 c0,0,4.6,4.6,11.7,4.6c6.8,0,11.3-3.4,11.3-9.7c0-9.4-12.8-9.4-12.8-12.9c0-1.1,0.9-1.9,2.4-1.9c3,0,5.4,2.4,5.4,2.4l4.6-5.4 c0,0-3.7-3.9-10.3-3.9c-6.4,0-10.8,3.6-10.8,8.8c0,9.7,13.1,9.4,13.1,13.2C573.5,91.8,572.5,92.7,570.7,92.7L570.7,92.7L570.7,92.7 z\"></path></g></svg>"

/***/ }),

/***/ "f/8b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_article_page_js__ = __webpack_require__("czBM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a822e81_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_article_page_vue__ = __webpack_require__("fb+H");
function injectStyle (ssrContext) {
  __webpack_require__("QyyU")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_article_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a822e81_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_article_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "f/Fq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "f/qq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_card_block_js__ = __webpack_require__("NoJm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d0afca_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_card_block_vue__ = __webpack_require__("jPv8");
function injectStyle (ssrContext) {
  __webpack_require__("TOgF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25d0afca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_card_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25d0afca_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_card_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fH87":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getSuggestionEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSuggestionsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_connection__ = __webpack_require__("dmZD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_blocks_image_image_class__ = __webpack_require__("gm3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_suggestion_class__ = __webpack_require__("HepC");




/**
 * Gets a center entry.
 */
var getSuggestionEntry = function getSuggestionEntry(value, slugOrId, recursive) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__data_connection__["a" /* getAction */])('suggestions', value, slugOrId, recursive).then(function (data) {
        if (data.data[0]) return processEntry(data.data[0]);
        if (data.data) return processEntry(data.data);
    });
};

/**
 * Gets a list of centers.
 */
var getSuggestionsList = function getSuggestionsList(recursive, page, perPage) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__data_connection__["b" /* listAction */])('suggestions', recursive, page, perPage).then(function (data) {
        return { content: processList(data.data), totalEntries: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
    });
};

/**
 * Process data.
 */
var processData = function processData(data) {
    var content = data.data;
    return content;
};

/**
 * Process Entry.
 */
var processEntry = function processEntry(data) {
    // console.log("SuggestionModel :: processEntry :: data -> ", data);

    var content = new __WEBPACK_IMPORTED_MODULE_2__classes_suggestion_class__["a" /* Suggestion */](data);

    if (content.image && content.image.length) content.image = new __WEBPACK_IMPORTED_MODULE_1__components_blocks_image_image_class__["a" /* Image */](content.image[0]);

    return content;
};

/**
 * Process List.
 */
var processList = function processList(data) {
    var content = data;

    content = content.map(function (value) {
        return processEntry(value);
    });

    return content;
};

/***/ }),

/***/ "fb+H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"page",style:('--openSection:' + _vm.openSection)},[_c('div',{staticClass:"page__wrapper"},[_c('div',{staticClass:"page__slide"},[(_vm.content.gallery.length || _vm.content.image)?_c('div',{staticClass:"page__slideshow element-colorize",attrs:{"data-logo-color":"#fff"}},[(_vm.content.gallery && _vm.content.gallery.length)?_c('slideshow-block',{attrs:{"items":_vm.content.gallery,"color":_vm.content.color}},_vm._l((_vm.content.gallery),function(image){return _c('div',{staticClass:"slide"},[_c('image-block',{staticClass:"expand",attrs:{"source":image,"wordpress":"wordpress"}})],1)}),0):_vm._e(),_c('div',[(!_vm.content.gallery.length && _vm.content.image)?_c('image-block',{staticClass:"expand",attrs:{"source":_vm.content.image,"wordpress":"true"}}):_vm._e()],1)],1):_vm._e(),_c('div',{staticClass:"page__header element-colorize",class:{ 'full' : _vm.content.gallery.length == 0 && !_vm.content.image },attrs:{"data-logo-color":"#fff"}},[_c('div',[(_vm.content.date)?_c('time',{staticClass:"type--display_2"},[_vm._v(_vm._s(_vm._f("date")(_vm.content.date,'short', null, ['/', '.'])))]):_vm._e(),_c('h1',{staticClass:"page__header__title type--display_2"},[_vm._v(_vm._s(_vm.content.title))]),(_vm.content.gallery.length == 0 && !_vm.content.image)?_c('h2',{staticClass:"page__header__excerpt type--headline",domProps:{"innerHTML":_vm._s(_vm.content.excerpt)}}):_vm._e()]),_c('div',{staticClass:"page__header__social"},[_c('h6',{staticClass:"type--display_1 type--title"},[_vm._v("Share")]),_c('a',{staticClass:"type--display_1 link",attrs:{"href":'https://www.facebook.com/sharer/sharer.php?u=' + _vm.pageUrl}},[_vm._v("Facebook")])])])]),_c('div',{staticClass:"page__slide element-colorize",attrs:{"data-logo-color":"#000"}},[_c('div',{staticClass:"page__content__c",on:{"scroll":function($event){return _vm.evalScroll()}}},[_c('div',{staticClass:"page__content"},[(_vm.content.gallery.length > 0 || _vm.content.image)?_c('div',{staticClass:"page__content__excerpt type--display_1",domProps:{"innerHTML":_vm._s(_vm.content.excerpt)}}):_vm._e(),_c('text-block',{staticClass:"type--body element-colorize",attrs:{"source":_vm.content.content,"data-logo-color":"#000"}})],1)])]),(_vm.content.exhibitions.length > 0)?_c('div',{staticClass:"page__slide"},[_c('section',{staticClass:"page__related"},[(_vm.isReady && _vm.content.exhibitions.length > 0)?_c('div',{staticClass:"element-colorize",attrs:{"data-logo-color":'#fff'}},[_c('h1',{staticClass:"type--body type--uppercase"},[_vm._v(_vm._s(_vm.$t('buttons.relatedExhibitions', _vm.language)))])]):_vm._e(),(_vm.content.exhibitions.length > 0)?_c('ul',{staticClass:"page__related__exhibitions"},_vm._l((_vm.content.exhibitions),function(exhibition){return _c('li',{staticClass:"page__related__item element-colorize",style:('--main-color:' + exhibition.color + '; --text-color:' + exhibition.textColor),attrs:{"data-logo-color":exhibition.textColor}},[(exhibition.date_ini || exhibition.date_end)?_c('h2',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm._f("date")(exhibition.date_ini,'short', null, ['/', '.']))+" – "+_vm._s(_vm._f("date")(exhibition.date_end,'short', null, ['/', '.'])))]):_vm._e(),_c('router-link',{attrs:{"to":'/' + _vm.language + '/exhibitions/' + exhibition.slug,"name":exhibition.title}},[_c('span',{staticClass:"type--display_3 link"},[_vm._v(_vm._s(exhibition.title))])])],1)}),0):_vm._e()])]):_vm._e()]),(_vm.content.exhibitions.length > 0)?_c('div',{staticClass:"page__controls"},[(_vm.openSection == 0)?_c('button',{staticClass:"page__controls__next",class:{ 'page__controls__next--white' : _vm.openSection == 1 },on:{"click":function($event){return _vm.nextSection()}}},[_c('span',{staticClass:"type--button type--uppercase"},[_vm._v(_vm._s(_vm.$t('buttons.more', _vm.language)))])]):_vm._e(),(_vm.openSection == 1)?_c('button',{staticClass:"page__controls__prev",class:{ 'page__controls__next--white' : _vm.openSection == 0 },on:{"click":function($event){return _vm.prevSection()}}},[_c('span',{staticClass:"type--button type--uppercase"},[_vm._v(_vm._s(_vm.$t('buttons.prev', _vm.language)))])]):_vm._e()]):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gAj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			randomNumber: null,
			hasScroll: true,
			hasScrolled: false,
			activeIndex: 0
		};
	},
	props: ["color", "items", "texts", "type"],
	created: function created() {
		// this.playSlideshow();
	},

	watch: {},
	methods: {
		scrollMove: function scrollMove(el, index) {
			// Identify Element based on template
			var gallery = this.$el.firstChild;
			var slide = null;

			if (gallery) {
				slide = gallery.children[index];
				// Define Scroll Value and Scroll
				var scrollValue = slide.offsetLeft + slide.offsetWidth - gallery.offsetWidth + 20;
				gallery.scroll({ top: 0, left: scrollValue, behavior: "smooth" });
			}
		},
		evalScroll: function evalScroll(el) {
			var gallery = el.srcElement;
			// Has Scrolled
			gallery.scrollLeft > 0 ? this.hasScrolled = true : this.hasScrolled = false;
			// Remaining Scroll
			gallery.scrollWidth - (gallery.scrollLeft + gallery.offsetWidth) === 0 ? this.hasScroll = false : this.hasScroll = true;

			// Spacer for Large devices
			var galleryWidth = gallery.offsetWidth;
			var scrollValue = this.hasScrolled ? gallery.scrollLeft + galleryWidth - 20 : gallery.scrollLeft + galleryWidth / 3;

			// Sets active Index Depending On scroll position.
			for (var index = 0; index < gallery.children.length; index++) {
				var slide = gallery.children[index];
				if (scrollValue > slide.offsetLeft + slide.offsetWidth / 2 && scrollValue < slide.offsetLeft + slide.offsetWidth + slide.offsetWidth / 2) {
					this.activeIndex = index;
				}
			}
		}
	}
});

/***/ }),

/***/ "gdaP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_models_exhibition_model__ = __webpack_require__("G3E8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_models_product_model__ = __webpack_require__("k/A9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_models_article_model__ = __webpack_require__("miYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_models_suggestion_model__ = __webpack_require__("fH87");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_i18n__ = __webpack_require__("TXmL");










/* harmony default export */ __webpack_exports__["a"] = ({
	name: "HomePage",
	data: function data() {
		return {
			current: [],
			publications: [],
			news: [],
			exhibitions: [],
			suggestions: [],
			isReadySuggestions: false,
			isReadyCurrent: false,
			isReadyPublications: false,
			isReadyExhibitions: false,
			isReadyNews: false,
			openIndex: -1,
			language: this.$route.params.lang,
			url: window.location.href
		};
	},

	props: {},
	created: function created() {
		this.getContent();
		__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("hideTitle", false);
	},

	watch: {
		"$route": function $route() {
			this.current = null;
			this.getContent();
			this.language = this.$route.params.lang;
			body.classList.remove("no--scroll");
			this.openIndex = -1;
		},
		openIndex: function openIndex(val) {
			var body = document.querySelector("body");
			if (val >= 0) body.classList.add("no--scroll");else body.classList.remove("no--scroll");
		}
	},
	computed: {},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var currentExhibition = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_3__data_models_exhibition_model__["a" /* getCurrentExhibitionsList */])().then(function (content) {
					_this.current = content.content;
					resolve(true);
				});
			});
			var suggestionsList = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_6__data_models_suggestion_model__["b" /* getSuggestionsList */])().then(function (content) {
					_this.suggestions = content.content;
					_this.isReadySuggestions = true;
					resolve(true);
				});
			});
			var productsList = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_4__data_models_product_model__["b" /* getProductsList */])(1).then(function (content) {
					_this.publications = content.content;
					_this.isReadyPublications = true;
					resolve(true);
				});
			});
			var newsList = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_5__data_models_article_model__["b" /* getNewsList */])(1, 1, 3).then(function (content) {
					_this.news = content.content;
					_this.isReadyNews = true;
					resolve(true);
				});
			});
			var exhibitionsList = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_3__data_models_exhibition_model__["c" /* getExhibitionsList */])(1, 1, 100).then(function (content) {
					_this.exhibitions = content.content;
					_this.isReadyExhibitions = true;
					resolve(true);
				});
			});
			__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.all([currentExhibition, exhibitionsList, productsList, newsList, suggestionsList]).then(function () {
				__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("evalColors", true);
				// Set Current Exhibition
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;

				try {
					for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.exhibitions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var exhibition = _step.value;
						var _iteratorNormalCompletion2 = true;
						var _didIteratorError2 = false;
						var _iteratorError2 = undefined;

						try {
							for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(_this.current), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
								var id = _step2.value;

								if (id === exhibition.id) {
									var index = _this.current.indexOf(id);
									_this.current.splice(index, 1, exhibition);
								}
							}
						} catch (err) {
							_didIteratorError2 = true;
							_iteratorError2 = err;
						} finally {
							try {
								if (!_iteratorNormalCompletion2 && _iterator2.return) {
									_iterator2.return();
								}
							} finally {
								if (_didIteratorError2) {
									throw _iteratorError2;
								}
							}
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}

				_this.isReadyCurrent = true;
				__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("PAGE_IS_READY", true);
			});
		}
	}
});

/***/ }),

/***/ "gm3k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);




var Image = function () {
	function Image(object) {
		__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Image);

		// this.title = object.title.rendered || null;
		this.description = object.description.rendered || null;
		this.caption = object.caption.rendered || null;
		this.alt = object.alt_text || null;
		this.media = object.media_type || null;
		this.sizes = {
			"original": this.getUrl(object, ["source_url", "full_url"]),
			"lazy": this.getUrl(object, ["media_details.sizes.lazy.source_url", "sizes.lazy.file"]),
			"thumbnail": this.getUrl(object, ["media_details.sizes.thumbnail.source_url", "sizes.thumbnail.file"]),
			"small": this.getUrl(object, ["media_details.sizes.small.source_url", "sizes.small.file"]),
			"medium": this.getUrl(object, ["media_details.sizes.medium.source_url", "sizes.medium.file"]),
			"large": this.getUrl(object, ["media_details.sizes.large.source_url", "sizes.large.file"]),
			"huge": this.getUrl(object, ["media_details.sizes.huge.source_url", "sizes.huge.file"])
		};
	}

	__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Image, [{
		key: "getUrl",
		value: function getUrl(object, path) {

			var url = void 0;
			var i = 0;

			while (!url && i < path.length) {
				if (__WEBPACK_IMPORTED_MODULE_2_lodash__["get"](object, path[i], null)) url = __WEBPACK_IMPORTED_MODULE_2_lodash__["get"](object, path[i]);else i++;
			}

			if (!url) return null;else if (url.indexOf("http") !== -1) {
				return url;
			} else {
				var array = object.full_url.split("/");
				array[array.length - 1] = url;
				return array.join("/");
			}
		}
	}]);

	return Image;
}();

/***/ }),

/***/ "guVY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button"},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h8Jo":
/***/ (function(module, exports) {

module.exports = {"en":{"pages":{"current":"Current Exhibition","exhibitions":"Exhibitions","news":"News","suggestions":"Mind Walks","about":"About","archive":"Archive","store":"Store","publications":"Publication | Publications","collection":"Collection","openBooksText":"OPEN BOOK: publications available online until 30.09.2020","openBooksTextFull":"Casa do Design publications and other editorial content are available for free online consultation until 30.09.2020. Publications can be purchased in print or digital format.","virtualTour":"Virtual Tour"},"content":{"store":{"title":"Casa do Design Store","text":"Casa do Design has a new store, where you may find Casa do Design exhibition catalogs and merchandising, among other design and art publications and a selection of Portuguese design objects, curated and managed by esad–idea, Research in Design and Art."}},"buttons":{"share":"Share","more":"See more","next":"Next","prev":"Previous","info":"Information","colophon":"Colophon","relatedExhibitions":"Related Exhibitions","relatedNews":"Related News","relatedPublications":"Related Publications","view":"View","credits":"Datasheet","documents":"Documents"},"footer":{"social":"Social Networks","copyright":"© Casa do Design. All rights reserved."},"store":{"new":"New","soldOut":"Sold Out","buy":"Buy"}},"pt":{"pages":{"current":"Em Exposição","exhibitions":"Exposições","suggestions":"Mind Walks","news":"Notícias","about":"Sobre","archive":"Arquivo","store":"Loja","publications":"Publicação | Publicações","collection":"Coleção Permanente","openBooksText":"OPEN BOOK: Publicações abertas para consulta até 30.09.2020","openBooksTextFull":"As publicações da Casa do Design e outros conteúdos editoriais são disponibilizados para consulta gratuita online até 30.09.2020. As publicações podem ser adquiridas em formato print e/ou digital.","virtualTour":"Visita Virtual"},"content":{"store":{"title":"Loja Casa do Design","text":"A Casa do Design tem um novo espaço-loja. Aqui se disponibilizam os catálogos das exposições e o merchandising da Casa do Design, entre outras publicações de design e arte e uma seleção de objetos de design português. O espaço tem curadoria e gestão da esad–idea, Investigação em Design e Arte."}},"buttons":{"share":"Partilhar","more":"Ver mais","next":"Próximo","prev":"Anterior","info":"Informações","colophon":"Ficha Técnica","relatedExhibitions":"Exposições Relacionadas","relatedNews":"Notícias Relacionadas","relatedPublications":"Publicações Relacionadas","view":"Visualizar","credits":"Ficha Técnica","documents":"Documentos"},"footer":{"social":"Redes Sociais","copyright":"© Casa do Design. Todos os direitos reservados."},"store":{"new":"Novo","soldOut":"Esgotado","buy":"Comprar"}}}

/***/ }),

/***/ "i/B4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Article; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var Article = function Article(object) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Article);

	// Info
	this.id = object.id || null;
	this.slug = object.slug || null;
	this.title = object.title.rendered || null;
	this.date = object.meta_box.settings.release_date || null;

	// Content
	this.excerpt = object.meta_box.content.sub_title || null;
	this.content = object.meta_box.content.content || null;

	// Images
	this.image = object.meta_box.content.image || null;
	this.gallery = object.meta_box.content.gallery || [];

	// Relations
	this.exhibitions = object.meta_box.news_to_exhibitions_to || [];

	// Graveyard
	// this.hashtags = object.meta_box.hashtags || null;
};

/***/ }),

/***/ "jLGC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('div',{staticClass:"exhibition",style:('--openSection:' + _vm.openSection + '; --main-color:' + _vm.content.color + '; --text-color:' + _vm.content.textColor),attrs:{"id":"exhibition"}},[_c('vue-headful',{attrs:{"title":_vm.content.title,"ogTitle":_vm.content.title,"description":_vm._f("stripHtml")(_vm.content.excerpt),"ogDescription":_vm._f("stripHtml")(_vm.content.excerpt),"image":_vm.content.image.sizes.large ? _vm.content.image.sizes.large : _vm.content.image.sizes.original,"ogImage":_vm.content.image.sizes.large ? _vm.content.image.sizes.large : _vm.content.image.sizes.original,"url":_vm.url}}),_c('div',{staticClass:"exhibition__slide"},[(_vm.content.image)?_c('div',{staticClass:"exhibition__slideshow element-colorize",attrs:{"data-logo-color":"#000"}},[(_vm.content.image)?_c('image-block',{staticClass:"expand",attrs:{"source":_vm.content.image,"wordpress":"true"}}):_vm._e()],1):_vm._e(),_c('header',{staticClass:"exhibition__header element-colorize",class:{ 'full' : !_vm.content.image },attrs:{"data-logo-color":_vm.content.textColor}},[_c('div',[(_vm.content.date_ini)?_c('time',{staticClass:"type--display_2",attrs:{"datetime":_vm.content.date_ini}},[_vm._v(_vm._s(_vm._f("date")(_vm.content.date_ini,'short', null, ['/', '.'])))]):_vm._e(),(_vm.content.date_ini && _vm.content.date_end)?_c('span',{staticClass:"type--display_2"},[_vm._v(_vm._s(' — '))]):_vm._e(),(_vm.content.date_end)?_c('time',{staticClass:"type--display_2",attrs:{"datetime":_vm.content.date_end}},[_vm._v(_vm._s(_vm._f("date")(_vm.content.date_end,'short', null, ['/', '.'])))]):_vm._e(),_c('h1',{staticClass:"exhibition__header__title type--display_2"},[_vm._v(_vm._s(_vm.content.title))]),(!_vm.content.image)?_c('h2',{staticClass:"exhibition__header__excerpt type--display_2",domProps:{"innerHTML":_vm._s(_vm.content.excerpt)}}):_vm._e()]),_c('div',{staticClass:"exhibition__header__social"},[_c('h4',{staticClass:"type--display_1 type--title"},[_vm._v("Share")]),_c('a',{staticClass:"type--display_1 link",attrs:{"href":'https://www.facebook.com/sharer/sharer.php?u=' + _vm.pageUrl}},[_vm._v("Facebook")])])])]),_c('main',{key:_vm.content.id,staticClass:"exhibition__slide element-colorize",attrs:{"data-logo-color":"#000"}},[_c('div',{staticClass:"exhibition__content__c",on:{"scroll":function($event){return _vm.evalScroll()}}},[_c('div',{staticClass:"exhibition__content"},[(_vm.content.image)?_c('h3',{staticClass:"exhibition__content__excerpt type--display_1",domProps:{"innerHTML":_vm._s(_vm.content.excerpt)}}):_vm._e(),_c('text-block',{staticClass:"type--body",attrs:{"source":_vm.content.content}}),(_vm.content.documents.length)?_c('div',{staticClass:"exhibition__content__documents"},[_c('h1',{staticClass:"exhibition__content__documents__title type--button"},[_vm._v(_vm._s(_vm.$t("buttons.documents", _vm.language))+" ")]),_vm._l((_vm.content.documents),function(document){return [_c('document-block',{attrs:{"title":document.title,"description":document.description,"file":document.file}})]})],2):_vm._e()],1)])]),_c('section',{staticClass:"exhibition__slide exhibition__slide--scroll u-scroll-bar",attrs:{"id":"secondary"}},[(_vm.content.gallery && _vm.content.gallery.length > 0)?_c('div',{staticClass:"exhibition__gallery black element-colorize",attrs:{"data-logo-color":'#fff'}},[_vm._l((_vm.content.videosLinks),function(video,index){return _c('div',{staticClass:"exhibition__gallery__media full"},[(video && video.url)?_c('div',{staticClass:"video__wrapper"},[_c('iframe',{staticClass:"video",attrs:{"src":video.url,"frameborder":"0","webkitallowfullscreen":"webkitallowfullscreen","mozallowfullscreen":"mozallowfullscreen","allowfullscreen":"allowfullscreen"}})]):_vm._e(),_c('div',{staticClass:"caption type--caption",domProps:{"innerHTML":_vm._s(video.caption)}})])}),_vm._l((_vm.content.videos),function(video,index){return _c('div',{staticClass:"exhibition__gallery__media full"},[(video.media === 'file')?_c('video',{staticClass:"exhibition__gallery__media__video",attrs:{"controls":"controls"}},[_c('source',{attrs:{"src":video.url,"type":"video/mp4"}})]):_vm._e(),(video.caption)?_c('div',{staticClass:"exhibition__gallery__media__info full"},[_c('div',{staticClass:"index type--caption"},[_vm._v(_vm._s(index + 1)+".")]),_c('div',{staticClass:"caption type--caption",domProps:{"innerHTML":_vm._s(video.caption)}})]):_vm._e()])}),_vm._l((_vm.content.gallery),function(image,index){return _c('div',{staticClass:"exhibition__gallery__media"},[_c('div',[(image.media === 'image')?_c('image-block',{staticClass:"exhibition__gallery__media__image expand",attrs:{"source":image,"wordpress":"wordpress","canFullScreen":"canFullScreen","caption":"caption","index":index}}):_vm._e()],1)])})],2):_vm._e(),(_vm.content.info && _vm.content.info.length > 0)?_c('div',{staticClass:"exhibition__content__side columns element-colorize",attrs:{"data-logo-color":_vm.content.textColor ? _vm.content.textColor : '#000'}},_vm._l((_vm.content.info),function(item){return _c('div',{staticClass:"exhibition__content__side__definition"},[_c('h4',{staticClass:"type--body"},[_vm._v(_vm._s(item.header))]),_c('hr',{staticClass:"type--body"}),_c('dl',[_vm._l((item.content),function(definition){return [_c('dt',{staticClass:"type--body type--italic"},[_vm._v(_vm._s(definition.title))]),_c('dd',{staticClass:"type--body"},[_vm._v(_vm._s(definition.value))])]})],2)])}),0):_vm._e(),(_vm.content.partners && _vm.content.partners.length)?_c('div',{staticClass:"exhibition__related__partners element-colorize",attrs:{"data-logo-color":'#000'}},[_vm._l((_vm.content.partners),function(group){return (group.header)?[_c('h1',{staticClass:"type--caption type--uppercase"},[_vm._v(_vm._s(group.header + ':'))]),_c('div',{staticClass:"exhibition__related__partners__group"},[_vm._l((group.content),function(partner){return [_c('a',{staticClass:"exhibition__related__partners__item",attrs:{"href":partner.websiteUrl}},[_c('img',{attrs:{"src":partner.url,"alt":partner.title}})])]})],2)]:_vm._e()})],2):_vm._e(),(_vm.isReady && _vm.content.products.length > 0)?_c('div',{staticClass:"exhibition__related__products element-colorize",attrs:{"data-logo-color":'#fff'}},[_c('div',{staticClass:"exhibition__related__header"},[_c('h1',{staticClass:"type--display_1 type--uppercase"},[_vm._v(_vm._s(_vm.$tc('pages.publications', 2, _vm.language)))])]),_c('div',{staticClass:"exhibition__related__products__content"},_vm._l((_vm.content.products),function(product){return _c('product-block',{key:product.id,attrs:{"item":product,"padding":"padding"}})}),1)]):_vm._e(),(_vm.isReady && _vm.content.news.length > 0)?_c('div',{staticClass:"exhibition__related__news element-colorize",attrs:{"data-logo-color":'#fff'}},[_c('div',{staticClass:"exhibition__related__header"},[_c('h1',{staticClass:"type--display_1 type--uppercase"},[_vm._v(_vm._s(_vm.$t('pages.news', _vm.language)))])]),_c('ul',{staticClass:"exhibition__related__news__content"},_vm._l((_vm.content.news),function(article){return _c('li',{staticClass:"exhibition__related__item"},[_c('h2',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm._f("date")(article.date,'short', null, ['/', '.'])))]),_c('router-link',{attrs:{"to":'/' + _vm.language + '/news/' + article.slug,"name":article.title}},[_c('h1',{staticClass:"type--display_1 link"},[_vm._v(_vm._s(article.title))])])],1)}),0)]):_vm._e()]),(_vm.content.news.length > 0 || (_vm.content.info && _vm.content.info.length > 0) || _vm.content.products.length > 0)?_c('div',{staticClass:"exhibition__controls"},[(_vm.openSection == 0)?_c('button',{staticClass:"exhibition__controls__next",class:{ 'exhibition__controls__next--white' : _vm.openSection == 1 },on:{"click":function($event){return _vm.nextSection()}}},[_c('span',{staticClass:"type--button type--uppercase"},[_vm._v(_vm._s(_vm.$t('buttons.more', _vm.language)))])]):_vm._e(),(_vm.openSection == 1)?_c('button',{staticClass:"exhibition__controls__prev",class:{ 'exhibition__controls__next--white' : _vm.openSection == 0 },on:{"click":function($event){return _vm.prevSection()}}},[_c('span',{staticClass:"type--button type--uppercase"},[_vm._v(_vm._s(_vm.$t('buttons.prev', _vm.language)))])]):_vm._e()]):_vm._e()],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jPv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",class:{ 'card--black' : _vm.black },style:('--main-color:' + _vm.item.color + '; --text-color:' + _vm.item.textColor)},[(_vm.item.gallery.length > 0 || _vm.item.image)?_c('div',{staticClass:"card__image",class:{ 'card__image--disabled' : _vm.item.type == 'sold_out' }},[(_vm.item.gallery.length > 0)?_c('carousel',{attrs:{"perPage":1,"loop":true,"paginationColor":"#000","paginationActiveColor":"#000"}},_vm._l((_vm.item.gallery),function(image,index){return _c('slide',{key:image.id,staticClass:"carousel__slide--card"},[_c('image-block',{staticClass:"carousel__slide__image expand",attrs:{"source":image,"wordpress":"true"}})],1)}),1):_c('image-block',{staticClass:"expand",attrs:{"source":_vm.item.image,"wordpress":"true"}})],1):_vm._e(),_c('div',{staticClass:"card__content",class:{ 'card__content--disabled' : _vm.item.type == 'sold_out' }},[(_vm.item.type == 'sold_out')?_c('div',{staticClass:"card__content__sold"},[_c('span',{staticClass:"type--display_1 type--uppercase"},[_vm._v(_vm._s(_vm.$t('store.soldOut', _vm.language))+"!")])]):_vm._e(),(_vm.item.type != 'sold_out')?_c('div',{staticClass:"card__content__buy",class:{ 'card__content__buy--black' : _vm.black }},[(_vm.item.price && _vm.item.type != 'sold_out')?_c('h3',{staticClass:"card__content__price type--display_1"},[_vm._v(_vm._s(_vm.item.price))]):_vm._e(),(_vm.item.url && _vm.item.type != 'sold_out')?_c('a',{staticClass:"card__content__buy__button type--display_1 link",attrs:{"href":_vm.item.url}},[_vm._v(_vm._s(_vm.$t('store.buy', _vm.language)))]):_vm._e(),(_vm.item.type == 'new')?_c('span',{staticClass:"card__new type--display_1 type--uppercase"},[_vm._v(_vm._s(_vm.$t('store.new', _vm.language))+" !")]):_vm._e()]):_vm._e(),_c('div',{staticClass:"card__content__title"},[_c('h1',{staticClass:"type--display_2 type--uppercase"},[_vm._v(_vm._s(_vm.item.title))]),(_vm.item.subTitle)?_c('h2',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.item.subTitle))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "je0H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jqpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_image_block_js__ = __webpack_require__("lEc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c255d3_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_image_block_vue__ = __webpack_require__("w+fA");
function injectStyle (ssrContext) {
  __webpack_require__("Wsat")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_image_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36c255d3_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_image_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k/A9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getProductEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getProductsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_connection__ = __webpack_require__("dmZD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__ = __webpack_require__("gm3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_file_class__ = __webpack_require__("aIMt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_product_class__ = __webpack_require__("71jN");





/**
 * Gets a center entry.
 */
var getProductEntry = function getProductEntry(value, slugOrId, recursive) {
	return Object(__WEBPACK_IMPORTED_MODULE_1__data_connection__["a" /* getAction */])("products", value, slugOrId, recursive).then(function (data) {
		if (data.data[0]) return processEntry(data.data[0]);
		if (data.data) return processEntry(data.data);
	});
};

/**
 * Gets a list of centers.
 */
var getProductsList = function getProductsList(recursive, page) {
	return Object(__WEBPACK_IMPORTED_MODULE_1__data_connection__["b" /* listAction */])("products", recursive, page).then(function (data) {
		return { content: processList(data.data), totalProducts: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
	});
};

/**
 * Process Entry.
 */
var processEntry = function processEntry(data) {
	var content = data;
	content = new __WEBPACK_IMPORTED_MODULE_4__classes_product_class__["a" /* Product */](content);

	if (content.image && data.related_ids[content.image]) content.image = new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](data.related_ids[content.image]);

	if (content.pdf && data.related_ids[content.pdf]) content.pdf = new __WEBPACK_IMPORTED_MODULE_3__classes_file_class__["a" /* File */](data.related_ids[content.pdf]);

	if (content.gallery) {
		content.gallery = content.gallery.map(function (image) {
			return new __WEBPACK_IMPORTED_MODULE_2__components_blocks_image_image_class__["a" /* Image */](data.related_ids[image]);
		});
	}
	return content;
};

/**
 * Process List.
 */
var processList = function processList(data) {
	var content = data;

	content = content.map(function (value) {
		return processEntry(value);
	});

	return content;
};

/***/ }),

/***/ "k/Bt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "k4nP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[(!_vm.error)?_c('vector',{staticClass:"loading__logo",attrs:{"src":__webpack_require__("Z1Rj")}}):_c('div',{staticClass:"message"},[_c('h1',{staticClass:"type--display_1"},[_vm._v(_vm._s(' Website not working please contact through web@esad.pt 🚑 '))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lEc6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__("Q7hp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
var _this2 = this;





/* harmony default export */ __webpack_exports__["a"] = ({
	data: function data() {
		return {
			loadImage: false,
			url: null,
			size: null,
			fullScreen: false
		};
	},

	props: ["source", "caption", "wordpress", "canFullScreen", "index"],
	created: function created() {
		var _this = this;

		window.addEventListener("resize", function () {
			if (_this.wordpress) _this.evalSize();
		});
	},
	mounted: function mounted() {
		this.lazyLoad();
		if (this.wordpress) this.evalSize();
	},

	watch: {
		"fullScreen": function fullScreen() {
			setTimeout(function () {
				_this2.evalSize();
			}, 200);
		}
	},
	methods: {
		evalSize: function evalSize() {
			var elementWidth = this.$el.parentElement.offsetWidth;
			var elementHeight = this.$el.parentElement.offsetHeight;

			var sizes = {
				huge: 1440,
				great: 1024,
				large: 768,
				medium: 320
			};

			var widthHeightRatio = 3;

			var size = this.size;

			if (elementWidth > sizes.huge || elementHeight > sizes.huge / widthHeightRatio) {
				size = "original";
			} else if (this.size !== "original" && (elementWidth > sizes.great || elementHeight > sizes.great / widthHeightRatio)) {
				size = "huge";
			} else if (this.size !== "huge" && this.size !== "original" && (elementWidth > sizes.large || elementHeight > sizes.large / widthHeightRatio)) {
				size = "great";
			} else if (this.size !== "great" && this.size !== "huge" && this.size !== "original" && (elementWidth > sizes.medium || elementHeight > sizes.medium / widthHeightRatio)) {
				size = "large";
			} else if (this.size !== "large" && this.size !== "great" && this.size !== "huge" && this.size !== "original" && elementWidth > 0) {
				size = "medium";
			}
			if (__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.source, "sizes[" + size + "]") == null) {
				size = "original";
			}

			this.size = size;

			this.url = this.source.sizes[size];
		},
		lazyLoad: function lazyLoad() {
			var _this3 = this;

			if ('IntersectionObserver' in window) {
				var image = this.$el;

				var options = {
					// If the image gets within 50px in the Y axis, start the download.
					root: null, // Page as root
					rootMargin: '0px',
					threshold: 0.1
				};

				var handleIntersection = function handleIntersection(entries, observer) {
					entries.forEach(function (entry) {
						if (entry.intersectionRatio > 0) {
							_this3.loadImage = true;
						}
					});
				};

				var observer = new IntersectionObserver(handleIntersection, options);

				observer.observe(image);
			} else {
				this.loadImage = true;
			}
		}
	}
});

/***/ }),

/***/ "mH1u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mPh3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('header-block'),_c('router-view',{staticClass:"container"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mTW9":
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 243.9 34.6\" style=\"enable-background:new 0 0 243.9 34.6;\" xml:space=\"preserve\"><style type=\"text/css\"> .st0{clip-path:url(#XMLID_20_);} </style><g id=\"XMLID_19_\"><defs><rect id=\"XMLID_1_\" width=\"243.9\" height=\"34.6\"></rect></defs><clipPath id=\"XMLID_20_\"><use xlink:href=\"#XMLID_1_\" style=\"overflow:visible;\"></use></clipPath><path id=\"XMLID_21_\" class=\"st0\" d=\"M231.6,28.4c-2.6,0-4.4-2-4.4-6v-0.4c0-4.1,1.7-6.1,4.5-6.1c2.7,0,4.4,2,4.4,6.1v0.4 C236.1,26.4,234.3,28.4,231.6,28.4 M228.9,34.6c3.4,0,5.8-1.9,7-4.3V34h8V10.5h-8v3.3c-1.3-2.4-3.5-3.9-7-3.9 c-5.2,0-9.8,4.3-9.8,12.3v0.4C219.1,30.7,223.7,34.6,228.9,34.6 M200.4,19.6c0.4-2.8,2.1-4.4,4.5-4.4c2.6,0,4,1.6,4.1,4.4H200.4z M204.9,34.6c7.1,0,11.2-3,11.9-8.3h-7.5c-0.3,1.6-1.4,2.8-4.1,2.8c-2.9,0-4.7-1.8-4.9-4.9h16.5V22c0-8.4-5.5-12.1-11.9-12.1 c-7.1,0-12.7,4.8-12.7,12.3v0.4C192.2,30.2,197.5,34.6,204.9,34.6 M176.1,28.4c-2.8,0-4.5-2-4.5-6v-0.4c0-4.1,1.6-6.1,4.6-6.1 c3,0,4.6,2.1,4.6,6.1v0.4C180.8,26.4,179.1,28.4,176.1,28.4 M173.3,34.6c3.5,0,6.1-1.9,7.3-4.4V34h8V0.2h-8v13.6 c-1.3-2.4-3.5-3.9-7.2-3.9c-5.6,0-10,4.3-10,12.3v0.4C163.4,30.7,167.9,34.6,173.3,34.6 M155.6,8.3c2.5,0,4.4-1.8,4.4-4.1 c0-2.4-1.9-4.2-4.4-4.2c-2.5,0-4.4,1.8-4.4,4.2C151.2,6.6,153.1,8.3,155.6,8.3 M151.6,34h8V10.5h-8V34z M108.6,23.2H147v-4.7h-38.4 V23.2z M91.6,28.4c-2.8,0-4.5-2-4.5-6v-0.4c0-4.1,1.6-6.1,4.6-6.1c3,0,4.6,2.1,4.6,6.1v0.4C96.3,26.4,94.6,28.4,91.6,28.4 M88.8,34.6c3.5,0,6.1-1.9,7.3-4.4V34h8V0.2h-8v13.6c-1.3-2.4-3.5-3.9-7.2-3.9c-5.6,0-10,4.3-10,12.3v0.4 C78.9,30.7,83.4,34.6,88.8,34.6 M63,28.4c-2.6,0-4.4-2-4.4-6v-0.4c0-4.1,1.7-6.1,4.5-6.1c2.7,0,4.4,2,4.4,6.1v0.4 C67.5,26.4,65.7,28.4,63,28.4 M60.3,34.6c3.4,0,5.8-1.9,7-4.3V34h8V10.5h-8v3.3c-1.3-2.4-3.5-3.9-7-3.9c-5.2,0-9.8,4.3-9.8,12.3 v0.4C50.5,30.7,55.1,34.6,60.3,34.6 M37.5,34.6c6.5,0,10.6-2.5,10.6-8.1c0-5-3.1-6.7-9.6-7.5c-2.9-0.4-3.9-0.8-3.9-1.9 c0-1.1,0.9-1.8,2.6-1.8c1.8,0,2.7,0.8,3,2.3h7.3c-0.5-5.6-4.6-7.6-10.4-7.6c-5.4,0-10.1,2.5-10.1,7.7c0,4.9,2.6,6.7,8.9,7.5 c3.2,0.4,4.4,1,4.4,2.1c0,1.2-0.9,1.9-2.9,1.9c-2.3,0-3.1-0.9-3.3-2.6h-7.4C26.9,31.8,30.8,34.6,37.5,34.6 M8.2,19.6 c0.4-2.8,2.1-4.4,4.5-4.4c2.6,0,4,1.6,4.1,4.4H8.2z M12.7,34.6c7.1,0,11.2-3,11.9-8.3h-7.5C16.8,27.8,15.7,29,13,29 c-2.9,0-4.7-1.8-4.9-4.9h16.5V22c0-8.4-5.5-12.1-11.9-12.1C5.6,9.9,0,14.7,0,22.2v0.4C0,30.2,5.4,34.6,12.7,34.6\"></path></g></svg>"

/***/ }),

/***/ "maFX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isReady)?_c('main',{staticClass:"publications-page element-colorize",attrs:{"data-logo-color":'#000'}},[_c('header',{staticClass:"publications-page__header"},[_c('h1',{staticClass:"publications-page__header__title type--display_1"},[_vm._v(_vm._s(_vm.$t('pages.store', _vm.language)))])]),(_vm.isReady)?_c('vue-headful',{attrs:{"title":'Casa do Design – ' + _vm.$t('pages.store', _vm.language),"ogTitle":'Casa do Design – ' + _vm.$t('pages.publications', _vm.language),"description":_vm.$t('pages.openBooksTextFull', _vm.language),"ogDescription":_vm.$t('pages.openBooksTextFull', _vm.language)}}):_vm._e(),_c('div',{staticClass:"publications-page__introduction"},[_vm._m(0),_c('div',{staticClass:"publications-page__introduction--text"},[_c('h2',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.$t('content.store.title', _vm.language )))]),_c('p',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.$t('content.store.text', _vm.language )))])])]),(_vm.isReady)?_c('div',{staticClass:"publications-page__publications"},_vm._l((_vm.content),function(product){return _c('div',{staticClass:"publication"},[_c('product-block',{attrs:{"item":product}})],1)}),0):_vm._e(),(_vm.isReady)?_c('nav',{staticClass:"publications-page__actions"},[_c('h2',{staticClass:"publications-page__actions__info type--display_1 type--uppercase"},[_vm._v(_vm._s(_vm.content.length)+"—"+_vm._s(_vm.totalProducts))]),(_vm.totalPages > _vm.currentPage)?_c('button',{staticClass:"link type--display_1 type--uppercase",on:{"click":function($event){return _vm.getMoreContent(_vm.currentPage + 1)}}},[_vm._v(_vm._s(_vm.$t('buttons.more', _vm.language )))]):_vm._e()]):_vm._e()],1):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publications-page__introduction--picture"},[_c('img',{attrs:{"src":__webpack_require__("Icai")}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "mbck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"archive element-colorize",attrs:{"data-logo-color":'#000'}},[_c('h2',{staticClass:"archive__title type--display_1 type--uppercase"},[_vm._v(_vm._s(_vm.$t('pages.exhibitions', _vm.language)))]),(!_vm.exhibitionsIsReady)?_c('loading-block'):_vm._e(),_vm._l((_vm.exhibitions),function(exhibition){return _c('div',{staticClass:"archive__item",on:{"mouseover":function($event){return _vm.showImage($event, exhibition.image)},"mouseleave":_vm.hideImage}},[_c('div',{staticClass:"archive__item__date"},[(exhibition.date_ini)?_c('time',{staticClass:"type--display_2",attrs:{"datetime":exhibition.date_ini}},[_vm._v(_vm._s(_vm._f("date")(exhibition.date_ini,'short', null, ['/', '.'])))]):_vm._e(),(exhibition.date_ini && exhibition.date_end)?_c('span',{staticClass:"type--display_2"},[_vm._v(_vm._s(' – '))]):_vm._e(),(exhibition.date_end)?_c('time',{staticClass:"type--display_2",attrs:{"datetime":exhibition.date_end}},[_vm._v(_vm._s(_vm._f("date")(exhibition.date_end,'short', null, ['/', '.'])))]):_vm._e()]),_c('router-link',{staticClass:"archive__item__title type--display_2 link",attrs:{"to":'/' + _vm.language + '/exhibitions/' + exhibition.slug}},[_vm._v(_vm._s(exhibition.title))])],1)}),_c('div',{staticClass:"archive__actions"},[_c('h2',{staticClass:"archive__actions__info type--display_1 type--uppercase"},[_vm._v(_vm._s(_vm.exhibitions.length)+"—"+_vm._s(_vm.totalExhibitions)+" "+_vm._s(_vm.$t('pages.exhibitions', _vm.language)))]),(_vm.totalPages > _vm.currentPage)?_c('button',{staticClass:"link type--display_1 type--uppercase",on:{"click":function($event){return _vm.getMoreContent(_vm.currentPage + 1)}}},[_vm._v(_vm._s(_vm.$t('buttons.more', _vm.language )))]):_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "miYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getArticleEntry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getNewsList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_connection__ = __webpack_require__("dmZD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_blocks_image_image_class__ = __webpack_require__("gm3k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_article_class__ = __webpack_require__("i/B4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__classes_exhibition_class__ = __webpack_require__("uV3G");





/**
 * Gets a center entry.
 */
var getArticleEntry = function getArticleEntry(value, slugOrId, recursive) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__data_connection__["a" /* getAction */])('posts', value, slugOrId, recursive).then(function (data) {
        if (data.data[0]) return processEntry(data.data[0]);
        if (data.data) return processEntry(data.data);
    });
};

/**
 * Gets a list of centers.
 */
var getNewsList = function getNewsList(recursive, page, perPage) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__data_connection__["b" /* listAction */])('posts', recursive, page, perPage).then(function (data) {
        return { content: processList(data.data), totalNews: Number(data.headers["x-wp-total"]), totalPages: Number(data.headers["x-wp-totalpages"]) };
    });
};

/**
 * Process data.
 */
var processData = function processData(data) {
    var content = data.data;
    return content;
};

/**
 * Process Entry.
 */
var processEntry = function processEntry(data) {

    var content = new __WEBPACK_IMPORTED_MODULE_2__classes_article_class__["a" /* Article */](data);

    if (content.image) content.image = new __WEBPACK_IMPORTED_MODULE_1__components_blocks_image_image_class__["a" /* Image */](data.related_ids[content.image[0]]);

    if (content.gallery.length) {
        content.gallery = content.gallery.map(function (image) {
            if (data.related_ids[image]) return new __WEBPACK_IMPORTED_MODULE_1__components_blocks_image_image_class__["a" /* Image */](data.related_ids[image]);
        });
    }

    if (content.exhibitions) {
        content.exhibitions = content.exhibitions.map(function (item) {
            if (data.related_ids[item]) return new __WEBPACK_IMPORTED_MODULE_3__classes_exhibition_class__["a" /* Exhibition */](data.related_ids[item]);
        });
    }
    return content;
};

/**
 * Process List.
 */
var processList = function processList(data) {
    var content = data;

    content = content.map(function (value) {
        return processEntry(value);
    });

    return content;
};

/***/ }),

/***/ "n8ch":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "DocumentBlock",
	data: function data() {
		return {
			isOpen: false,
			language: this.$route.params.lang
		};
	},

	props: ["title", "description", "file"],
	created: function created() {},

	watch: {
		"$route": function $route() {
			this.language = this.$route.params.lang;
		}
	},
	computed: {},
	methods: {
		toggleObject: function toggleObject() {
			this.isOpen = !this.isOpen;
		}
	}
});

/***/ }),

/***/ "nORL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "PlaygroundPage",
	data: function data() {
		return {};
	},

	props: {},
	created: function created() {},

	watch: {},
	computed: {},
	methods: {}
});

/***/ }),

/***/ "nZh1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_about_page_js__ = __webpack_require__("+Emi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb62bdda_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_about_page_vue__ = __webpack_require__("p7Is");
function injectStyle (ssrContext) {
  __webpack_require__("k/Bt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_about_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb62bdda_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_about_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oM49":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p7Is":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"about element-colorize",attrs:{"data-logo-color":"#000"}},[_c('vue-headful',{attrs:{"description":_vm._f("stripHtml")(_vm.content.content),"ogDescription":_vm._f("stripHtml")(_vm.content.content),"url":_vm.url}}),(_vm.content.content)?_c('div',{staticClass:"about__text type--display_1",domProps:{"innerHTML":_vm._s(_vm.content.content.rendered)}}):_vm._e(),(_vm.content.meta_box.credits)?_c('div',{staticClass:"about__credits"},_vm._l((_vm.content.meta_box.credits.info),function(item){return _c('div',{staticClass:"about__credits__definition"},[_c('h2',{staticClass:"about__credits__definition__title type--body"},[_vm._v(_vm._s(item.header))]),_c('dl',{staticClass:"about__credits__definition__list"},_vm._l((item.content),function(definition){return _c('div',{staticClass:"about__credits__definition__item"},[_c('dt',{staticClass:"type--body type--italic"},[_vm._v(_vm._s(definition.title))]),_c('dd',{staticClass:"about__credits__definition__value type--body"},[_vm._v(_vm._s(definition.value))])])}),0)])}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "py3E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
	name: "SideContentBlock",
	data: function data() {
		return {};
	},

	props: ["title", "color", "dataColor", "index", "last", "openIndex"],
	created: function created() {},

	watch: {},
	computed: {},
	methods: {}
});

/***/ }),

/***/ "rQ6Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"contacts element-colorize",attrs:{"data-logo-color":"#fff"}},[_c('h1',{staticClass:"type--display_2"},[_vm._v("🛠 ERROR 404 ! ")]),_c('h1',{staticClass:"type--display_2"},[_vm._v("PAGE NOT FOUND.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rQPl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_models_page_model__ = __webpack_require__("yu3g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");




/* harmony default export */ __webpack_exports__["a"] = ({
	name: "ContactsPage",
	data: function data() {
		return {
			content: null,
			isReady: false
		};
	},

	props: {},
	created: function created() {
		this.getContent();
	},

	watch: {},
	computed: {},
	methods: {
		getContent: function getContent() {
			var _this = this;

			var contentReady = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				Object(__WEBPACK_IMPORTED_MODULE_1__data_models_page_model__["a" /* getTemplatePage */])('pages/contact-page.php').then(function (content) {
					_this.content = content, _this.isReady = true;
				});
			});
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([contentReady]).then(function () {
				__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("pageIsReady", true);
			});
		}
	}
});

/***/ }),

/***/ "rdP9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sb3R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_models_page_model__ = __webpack_require__("yu3g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_timers__ = __webpack_require__("162o");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_timers__);





/* harmony default export */ __webpack_exports__["a"] = ({
	name: "HeaderBlock",
	data: function data() {
		return {
			menuIsActive: false,
			content: [],
			isReady: false,
			colorElements: [],
			buttonHover: false,
			hiddenTitle: false,
			language: this.$route.params.lang,
			name: this.$route.name,
			newsletterOpen: false
		};
	},

	props: {},
	created: function created() {
		var _this = this;

		this.getContent();
		__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("evalColors", function () {
			_this.getSections();
			if (document.getElementById("primary")) {
				document.getElementById("primary").addEventListener("scroll", function () {
					_this.getSections();
				});
			}
			if (document.getElementById("secondary")) {
				document.getElementById("secondary").addEventListener("scroll", function () {
					_this.getSections();
				});
			}
			window.addEventListener("scroll", function () {
				// console.log("EVAL COLORS !! ")
				_this.getSections();
			});
		});
		__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$on("hideTitle", function (value) {
			_this.hiddenTitle = value;
		});
	},

	watch: {
		"$route": function $route() {
			this.sections = [];
			this.language = this.$route.params.lang;
			this.name = this.$route.name;
			this.menuIsActive = false;
			this.getSections();
			this.getContent();
			__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("toggleMenu", false);
		},
		"menuIsActive": function menuIsActive() {
			var _this2 = this;

			if (this.menuIsActive) {
				this.bodyScroll();
				this.buttonHover = false;

				setTimeout(function () {
					var menuElement = document.querySelector(".header-block__nav__menu");
					var logoElement = document.querySelector(".header-block__nav__logo");
					menuElement.querySelector(".header-block__nav__menu__text").style.color = "#000";
					logoElement.querySelector(".header-block__nav__menu__vector").style.color = "#000";
				}, 500);
			} else {
				this.bodyScroll(true);
			}
			setTimeout(function () {
				_this2.getSections();
			}, 300);
		}
	},
	computed: {},
	mounted: function mounted() {
		var _this3 = this;

		window.addEventListener("scroll", function () {
			_this3.getSections();
		});
		window.addEventListener("resize", function () {
			_this3.getSections();
		});
	},

	methods: {
		getContent: function getContent() {
			var _this4 = this;

			Object(__WEBPACK_IMPORTED_MODULE_1__data_models_page_model__["a" /* getTemplatePage */])("pages/contact-page.php").then(function (content) {
				_this4.content = content;
				_this4.isReady = true;
			});
		},
		toggleMenu: function toggleMenu(close) {
			this.menuIsActive = !this.menuIsActive;
			__WEBPACK_IMPORTED_MODULE_2__main__["bus"].$emit("toggleMenu", true);
		},
		bodyScroll: function bodyScroll(remove) {
			if (remove) document.querySelector("body").classList.remove("no--scroll");else document.querySelector("body").classList.add("no--scroll");
		},
		menuHover: function menuHover(state) {
			if (this.menuIsActive) this.buttonHover = false;else this.buttonHover = state;
		},
		getSections: function getSections() {
			var _this5 = this;

			var elements = document.getElementsByClassName("element-colorize");
			var getColorElements = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
				for (var i = 0; i < elements.length; i++) {
					if (elements[i].attributes["data-logo-color"]) {
						_this5.colorElements.push(elements[i]);
					}
					if (i + 1 == elements.length) resolve(true);
				}
			});
			__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([getColorElements]).then(function () {
				_this5.evalColorElement(".header-block__nav__logo", "svg");
				_this5.evalColorElement(".header-block__nav__menu", "span");
				// this.evalColorLogo(".header__title");
			});
		},
		evalColorElement: function evalColorElement(value, type) {
			var menuElement = document.querySelector(value);
			var found = null;
			var i = 0;

			while (!found && i < this.colorElements.length) {

				var element = this.colorElements[i].getBoundingClientRect();

				if (menuElement && menuElement.getBoundingClientRect().top + menuElement.getBoundingClientRect().height / 2 >= element.top && menuElement.getBoundingClientRect().left + menuElement.getBoundingClientRect().width / 2 >= element.left && menuElement.getBoundingClientRect().right - menuElement.getBoundingClientRect().width / 2 <= element.right && menuElement.getBoundingClientRect().bottom - menuElement.getBoundingClientRect().height / 2 <= element.bottom) {
					if (type == "svg") {
						menuElement.querySelector(".header-block__nav__logo__vector").style.stroke = this.colorElements[i].attributes["data-logo-color"].value;
					}
					if (type == "span") {
						menuElement.querySelector(".header-block__nav__menu__text").style.color = this.colorElements[i].attributes["data-logo-color"].value;
					} else {
						menuElement.style.color = this.colorElements[i].attributes["data-logo-color"].value;
					}
					found = true;
				}
				i++;
			}
		}
	}
});

/***/ }),

/***/ "tk8Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tpo5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_page_js__ = __webpack_require__("94TT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194d3dcf_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_news_page_vue__ = __webpack_require__("0csj");
function injectStyle (ssrContext) {
  __webpack_require__("rdP9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-194d3dcf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_news_page_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_194d3dcf_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_news_page_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u5J3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vector_vue__ = __webpack_require__("QkVt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b7402c6_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_vector_vue__ = __webpack_require__("044V");
function injectStyle (ssrContext) {
  __webpack_require__("aNx+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b7402c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_vector_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b7402c6_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_vector_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uV3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Exhibition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);

var Exhibition = function Exhibition(object) {
	__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Exhibition);

	// Identifier
	this.id = object.id || null;
	this.slug = object.slug || null;
	this.title = object.title.rendered || null;

	//Content
	this.type = object.meta_box.settings.state || null;
	this.date_ini = object.meta_box.settings.date_ini || null;
	this.date_end = object.meta_box.settings.date_end || null;
	this.excerpt = object.meta_box.content.short_content || null;
	this.content = object.meta_box.content.content || null;
	this.info = object.meta_box.credits.info || [];

	// Images
	this.image = object.meta_box.content.image || null;
	this.gallery = object.meta_box.content.gallery || [];
	this.videos = object.meta_box.content.videos || [];
	this.videosLinks = object.meta_box.content.videos_links || [];

	// Design
	this.color = object.meta_box.settings.main_color || null;
	this.textColor = object.meta_box.settings.text_color || null;

	// Relations
	this.partners = object.meta_box.credits.partners || null;
	this.news = object.meta_box.news_to_exhibitions_from || [];
	this.products = object.meta_box.exhibitions_to_products_to || [];
	this.documents = object.meta_box.exhibitions_to_documents_to || [];
};

/***/ }),

/***/ "v/LG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_slideshow_block_js__ = __webpack_require__("gAj2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_304b110e_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_slideshow_block_vue__ = __webpack_require__("Yrn1");
function injectStyle (ssrContext) {
  __webpack_require__("mH1u")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-304b110e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_slideshow_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_304b110e_hasScoped_true_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_slideshow_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v7bE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_loading_block_js__ = __webpack_require__("J9Ry");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1c4495_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_loading_block_vue__ = __webpack_require__("k4nP");
function injectStyle (ssrContext) {
  __webpack_require__("a68k")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_loading_block_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a1c4495_hasScoped_false_transformToRequire_video_src_source_src_srcset_vector_src_img_src_image_xlink_href_node_modules_vue_loader_lib_template_compiler_preprocessor_engine_pug_node_modules_vue_loader_lib_selector_type_template_index_0_loading_block_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vURb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page"},[_c('vue-headful',{attrs:{"title":'Casa do Design Matosinhos',"ogTitle":'Casa do Design Matosinhos',"description":'A Casa do Design pretende afirmar-se como um espaço central de exposição, divulgação e produção crítica de conhecimento em design com um enfoque no design português. A par de uma programação regular — centrada em exposições que suscitem reflexão e debate sobre a cultura do design contemporâneo ou, noutra perspetiva, que investiguem, recolham e preservem conhecimento histórico ligado à evolução do design nas suas diversas áreas — será criada uma coleção permanente e um acervo documental que potencializem a investigação e disseminação de conhecimento em design.',"ogDescription":'A Casa do Design pretende afirmar-se como um espaço central de exposição, divulgação e produção crítica de conhecimento em design com um enfoque no design português. A par de uma programação regular — centrada em exposições que suscitem reflexão e debate sobre a cultura do design contemporâneo ou, noutra perspetiva, que investiguem, recolham e preservem conhecimento histórico ligado à evolução do design nas suas diversas áreas — será criada uma coleção permanente e um acervo documental que potencializem a investigação e disseminação de conhecimento em design.',"image":'https://staging.casa-design.pt/static/images/website_preview_small.jpg',"ogImage":'https://staging.casa-design.pt/static/images/website_preview_small.jpg',"url":_vm.url}}),_c('section',{staticClass:"primary u-scrollbar",attrs:{"id":"primary"}},[(!_vm.isReadyCurrent)?_c('loading-block'):_vm._e(),_vm._l((_vm.current),function(exhibition){return (_vm.current.length > 0 && _vm.isReadyCurrent)?_c('article',{key:exhibition.id,staticClass:"primary__exhibition",style:('--main-color:' + exhibition.color + '; --text-color:' + exhibition.textColor)},[(( exhibition.gallery && exhibition.gallery.length ) || exhibition.image)?_c('div',{staticClass:"primary__exhibition__slideshow element-colorize",attrs:{"data-logo-color":'#000'}},[(exhibition.image)?_c('image-block',{staticClass:"primary__exhibition__image expand",attrs:{"source":exhibition.image,"wordpress":true}}):_vm._e()],1):_vm._e(),_c('div',{staticClass:"primary__exhibition__content element-colorize",attrs:{"data-logo-color":exhibition.textColor}},[_c('router-link',{staticClass:"link",attrs:{"to":_vm.language + '/exhibitions/'+ exhibition.slug,"name":"exhibition.title"}},[(exhibition.date_ini || exhibition.date_end)?_c('time',{staticClass:"type--display_2"},[_vm._v(_vm._s(_vm._f("date")(exhibition.date_ini,'short', null, ['/', '.']))+" – "+_vm._s(_vm._f("date")(exhibition.date_end,'short', null, ['/', '.'])))]):_vm._e(),(exhibition.title)?_c('h1',{staticClass:"type--display_2"},[_vm._v(_vm._s(exhibition.title))]):_vm._e()]),(exhibition.excerpt)?_c('h2',{staticClass:"type--display_2"},[_vm._v(_vm._s(exhibition.excerpt))]):_vm._e()],1)]):_vm._e()})],2),_c('section',{staticClass:"secondary u-scrollbar",attrs:{"id":"secondary"}},[(!_vm.isReadyNews && !_vm.isReadyExhibitions && !_vm.isReadyPublications)?_c('loading-block'):_vm._e(),(_vm.isReadyNews)?_c('section',{staticClass:"secondary__container black element-colorize padding",attrs:{"data-logo-color":'#fff'}},[_c('div',{staticClass:"secondary__container__header"},[_c('router-link',{attrs:{"to":{ name: 'NewsPage' },"name":"NewsPage"}},[_c('h2',{staticClass:"type--display_1 type--uppercase"},[_vm._v(_vm._s(_vm.$t('pages.news', _vm.language )))])])],1),_vm._l((_vm.news),function(article){return _c('article',{key:article.id},[(article.date)?_c('time',{staticClass:"type--display_2"},[_vm._v(_vm._s(_vm._f("date")(article.date,'short', null, ['/', '.'])))]):_vm._e(),_c('router-link',{staticClass:"type--display_2 link",attrs:{"to":_vm.language + '/news/' + article.slug,"name":"article.title"}},[_vm._v(_vm._s(article.title))])],1)})],2):_vm._e(),(_vm.isReadyExhibitions)?_c('section',{staticClass:"secondary__container element-colorize padding",attrs:{"data-logo-color":'#000'}},[_c('div',{staticClass:"secondary__container__header"},[_c('router-link',{staticClass:"title",attrs:{"to":{ name: 'ArchivePage' },"name":"ArchivePage"}},[_c('span',{staticClass:"type--display_1 type--uppercase link"},[_vm._v(_vm._s(_vm.$t('pages.exhibitions', _vm.language )))])])],1),_vm._l((_vm.exhibitions),function(exhibition){return _c('article',{key:exhibition.id},[(exhibition.date_ini || exhibition.date_end)?_c('time',{staticClass:"type--display_2"},[_vm._v(_vm._s(_vm._f("date")(exhibition.date_ini,'short', null, ['/', '.']))+" – "+_vm._s(_vm._f("date")(exhibition.date_end,'short', null, ['/', '.'])))]):_vm._e(),_c('router-link',{staticClass:"type--display_2 link",attrs:{"to":_vm.language + '/exhibitions/' + exhibition.slug}},[_vm._v(_vm._s(exhibition.title))])],1)})],2):_vm._e(),(_vm.isReadyPublications)?_c('section',{staticClass:"secondary__container gray element-colorize",attrs:{"data-logo-color":'#000'}},[_c('div',{staticClass:"secondary__container__header padding"},[_c('router-link',{attrs:{"to":{ name: 'PublicationsPage' },"name":"PublicationsPage"}},[_c('h1',{staticClass:"type--display_1 type--uppercase link"},[_vm._v(_vm._s(_vm.$t('pages.store', _vm.language )))])])],1),_c('div',{staticClass:"flex"},_vm._l((_vm.publications),function(publication){return _c('product-block',{key:publication.id,attrs:{"item":publication,"padding":"padding"}})}),1)]):_vm._e(),(_vm.isReadySuggestions)?_c('section',{staticClass:"secondary__container element-colorize padding",attrs:{"data-logo-color":'#000'}},[_c('router-link',{staticClass:"secondary__container__header suggestion link",attrs:{"to":{ name: 'SuggestionsPage', params: { suggestion: _vm.suggestions[0].slug } },"name":"MindWalksPage"}},[_c('h1',{staticClass:"type--display_1"},[_vm._v(_vm._s(_vm.$t('pages.suggestions', _vm.language )))])]),_c('hr'),_vm._l((_vm.suggestions),function(suggestion,index){return (index < 3)?_c('article',{staticClass:"suggestion"},[_c('router-link',{staticClass:"suggestion__header",attrs:{"to":{ name: 'SuggestionsPage', params: { suggestion: suggestion.slug } },"name":"MindWalksPage"}},[_c('time',{staticClass:"type--display_2 type--italic"},[_vm._v(_vm._s(_vm._f("date")(suggestion.date,'short', null, ['/', '.'])))]),_c('span',{staticClass:"type--display_2"},[_vm._v(_vm._s(suggestion.author))])])],1):_vm._e()}),_c('router-link',{attrs:{"to":{ name: 'SuggestionsPage', params: { suggestion: _vm.suggestions[0].slug } },"name":"SuggestionsPage"}},[_c('span',{staticClass:"type--button type--uppercase link"},[_vm._v(_vm._s(_vm.$t('buttons.more', _vm.language )))])])],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w+BA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stripHtml;

/*
** Strip HTML
*/
function stripHtml(data) {
    if (typeof data !== "string") return "";
    var doc = new DOMParser().parseFromString(data, "text/html");
    return doc.body.textContent || "";
}

/***/ }),

/***/ "w+fA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.source)?_c('div',{staticClass:"image-block",class:{ 'image-block--pixelated' : !_vm.loadImage, 'fullscreen' : _vm.fullScreen }},[(_vm.wordpress)?[(_vm.loadImage)?_c('img',{staticClass:"image-block__wordpress",attrs:{"src":_vm.url,"alt":_vm.source.alt}}):_c('img',{staticClass:"image-block__lazy-load",attrs:{"src":_vm.source.sizes.lazy,"alt":_vm.source.alt}})]:[_c('img',{attrs:{"src":_vm.source}})],_c('div',{staticClass:"image-block__info"},[(_vm.canFullScreen)?_c('div',{staticClass:"image-block__actions"},[(!_vm.fullScreen)?_c('button',{key:"1",staticClass:"image-block__actions__fullscreen type--caption",on:{"click":function($event){_vm.fullScreen = true}}},[_c('vector',{staticClass:"icon",attrs:{"src":__webpack_require__("cT6L")}})],1):_c('button',{key:"2",staticClass:"image-block__actions__fullscreen type--caption",on:{"click":function($event){_vm.fullScreen = false}}},[_c('vector',{staticClass:"icon",attrs:{"src":__webpack_require__("7znA")}})],1)]):_vm._e(),(_vm.source.caption && _vm.caption)?_c('div',{staticClass:"image-block__caption"},[(_vm.index + 1)?_c('span',{staticClass:"type--caption",domProps:{"innerHTML":_vm._s(_vm.index + 1 + '.')}}):_vm._e(),_c('span',{staticClass:"type--caption",domProps:{"innerHTML":_vm._s(_vm.source.caption)}})]):_vm._e()])],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "x/kf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = transform;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main_js__ = __webpack_require__("NHnr");


function transform(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { isRange: false, returnElements: false };


    var dates = void 0;
    var dateStrings = void 0;
    var compositeString = void 0;
    var compositeArray = void 0;
    var rangeSeparator = void 0;
    var multipleSeparator = void 0;

    // Null check.
    if (!data) {
        throwError("No data was specified. Returning empty.");
        return "";
    }

    // Convert data to array and
    // sanitize dates by converting to appropriate type.
    if (typeof data === "string") {
        // console.log("this is string");
        dates = [new Date(data)];
    } else if (data instanceof Date) {
        // console.log("this is date");
        dates = [data];
    } else if (data instanceof Array && data.length) {
        // console.log("this is array");
        dates = data.map(function (date) {
            if (date) {
                return new Date(date);
            } else {
                throwError("Date " + date + " is not valid.");
            }
        });
    }

    if (options.isRange && dates.length !== 2) {
        throwError("Can't calculate range if " + dates.length + " dates were specified. Please specify exactly 2 (the first and last).");
    }

    // Remove repeated dates.
    // dates = dates.filter((date: Date, index: number) => {
    // 	if (dates[index+1] && (date.getTime() === dates[index+1].getTime())) {
    // 		return true;
    // 	}
    // });

    // console.log("dates before checkin types", dates);

    // Get similarities and differences in dates type values.
    var similTypes = getDateTypesDifferences(dates).similar;
    var diffTypes = getDateTypesDifferences(dates).different;

    // console.log("similTypes", similTypes);
    // console.log("diffTypes", diffTypes);

    var separator = options.isRange ? rangeSeparator : multipleSeparator;

    //
    // Compose date string.
    //
    // console.log(`var dates has ${dates.length} dates and isRange is ${options.isRange}`);
    // Exactly one date
    if (dates.length === 1) {
        dateStrings = [getDateString(dates[0], evalYear(dates[0], ["d", "m", "y"]))];
        if (options.returnElements) {
            compositeString = "<time datetime=" + getDateFormat(dates[0]) + ">" + dateStrings[0] + "</time>";
        } else {
            compositeString = dateStrings[0];
        }
        // Multiple dates
    } else {
        dateStrings = dates.map(function (date) {
            return getDateString(date, diffTypes);
        });

        if (options.returnElements) {
            compositeArray = dateStrings.map(function (dateStrings, index) {
                return "<time datetime=" + getDateFormat(dates[index]) + ">" + dateStrings + "</time>";
            });
            compositeString = compositeArray.join(separator) + " " + getDateString(dates[0], evalYear(dates[0], similTypes));
        } else {
            compositeString = dateStrings.join(separator) + " " + getDateString(dates[0], evalYear(dates[0], similTypes));
        }
    }

    return compositeString;
}

/**
 * Evaluate if year is necessary.
 */
function evalYear(date, format) {
    var numberOfMonths = 6;
    var today = new Date();
    var future = new Date(new Date().setMonth(today.getMonth() + numberOfMonths));

    // It's $numberOfMonths months from now, remove year.
    if (date.getTime() > today.getTime() && date.getTime() < future.getTime()) {
        format.splice(format.indexOf("y", 1));
        return format;
    } else {
        return format;
    }
}

/**
 * Returns a date in format ISO 8601 without time.
 */
function getDateFormat(date) {
    return date.toISOString().substring(0, 10);
}

/**
 * Returns array of similar and different date values
 * E.g.: ['my', 'd'] means dates are in the same month and year but
 * different days.
 */
function getDateTypesDifferences(dates) {

    var similTypes = ["d", "m", "y"];
    var diffTypes = [];

    var firstDateDay = dates[0].getDate();
    var firstDateMonth = dates[0].getMonth();
    var firstDateYear = dates[0].getFullYear();

    // Find different days.
    if (dates.find(function (date) {
        var thisDateDay = date.getDate();

        if (firstDateDay !== thisDateDay) {
            return true;
        } else {
            return false;
        }
    })) {
        similTypes = ["m", "y"];
        diffTypes = ["d"];
    }

    // Find different months.
    if (dates.find(function (date) {
        var thisDateMonth = date.getMonth();

        if (firstDateMonth !== thisDateMonth) {
            return true;
        } else {
            return false;
        }
    })) {
        similTypes = ["y"];
        diffTypes = ["d", "m"];
    }

    // Find different years.
    if (dates.find(function (date) {
        var thisDateYear = date.getFullYear();

        if (firstDateYear !== thisDateYear) {
            return true;
        } else {
            return false;
        }
    })) {
        diffTypes = ["d", "m", "y"];
        similTypes = [];
    }

    return {
        similar: similTypes,
        different: diffTypes
    };
}

/**
 * Returns short month string.
 */
function getDateString(date, format) {
    if (date) {

        // Set variables.
        var d = date.toLocaleString(__WEBPACK_IMPORTED_MODULE_0__main_js__["i18n"].locale, { day: "numeric" });
        var m = date.toLocaleString(__WEBPACK_IMPORTED_MODULE_0__main_js__["i18n"].locale, { month: "short" });
        var y = date.toLocaleString(__WEBPACK_IMPORTED_MODULE_0__main_js__["i18n"].locale, { year: "numeric" });

        // Create array with values based on specified format.
        var compositeDateArray = format.map(function (item) {
            return eval(item);
        });

        // Join array and return.
        return compositeDateArray.join(" ");
    } else {
        throwError("No date was specified in 'getDateString()'.");
    }
}

/**
 * Throw an error if transform is not well defined
 */
function throwError(error) {
    throw Error("TnsjDatePipe :: " + (error || 'Some error occurred.'));
}

/***/ }),

/***/ "x0lU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xksy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("playground")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "yu3g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPageEntry */
/* unused harmony export getPagesList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTemplatePage; });
/* unused harmony export getTemplateList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_connection__ = __webpack_require__("dmZD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_blocks_image_image_class__ = __webpack_require__("gm3k");



/**
 * Gets a center entry.
 */
var getPageEntry = function getPageEntry(value) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__data_connection__["a" /* getAction */])('pages', value, 'slug').then(function (data) {
		if (data.data[0]) return processEntry(data.data[0]);
		if (data.data) return processEntry(data.data);
	});
};

/**
 * Gets a list of centers.
 */
var getPagesList = function getPagesList() {
	return Object(__WEBPACK_IMPORTED_MODULE_0__data_connection__["b" /* listAction */])('pages').then(function (data) {
		return processList(data.data);
	});
};

/**
 * Gets a Template Page entry.
 */
var getTemplatePage = function getTemplatePage(value) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__data_connection__["a" /* getAction */])('templates', value, 'slug').then(function (data) {
		// console.log("Data", data)

		if (data.data) {
			if (data.data[0]) return processEntry(data.data[0]);else return processEntry(data.data);
		}
	});
};

/**
 * Gets a list of Template Pages.
 */
var getTemplateList = function getTemplateList(value) {
	return Object(__WEBPACK_IMPORTED_MODULE_0__data_connection__["b" /* listAction */])('templates', value).then(function (data) {
		return processList(data.data);
	});
};

/**
 * Process Entry.
 */
var processEntry = function processEntry(data) {
	var content = data;
	if (content.better_featured_image) content.better_featured_image = new __WEBPACK_IMPORTED_MODULE_1__components_blocks_image_image_class__["a" /* Image */](content.better_featured_image);

	if (content.meta_box.gallery) {
		content.meta_box.gallery = content.meta_box.gallery.map(function (image) {
			return new __WEBPACK_IMPORTED_MODULE_1__components_blocks_image_image_class__["a" /* Image */](image);
		});
	}
	return content;
};

/**
 * Process List.
 */
var processList = function processList(data) {
	var content = data;

	content.map(function (edition) {
		processEntry(edition);
	});

	return content;
};

/***/ }),

/***/ "zNeH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_headful__ = __webpack_require__("WiKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_headful___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_headful__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_blocks_header_header_block_vue__ = __webpack_require__("OxS7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_blocks_footer_footer_block_vue__ = __webpack_require__("JsOn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_blocks_vector_vue__ = __webpack_require__("u5J3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_blocks_image_image_block_vue__ = __webpack_require__("jqpD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_blocks_input_input_block_vue__ = __webpack_require__("ODQc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_blocks_loading_loading_block_vue__ = __webpack_require__("v7bE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_blocks_text_text_block_vue__ = __webpack_require__("83xS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_blocks_button_button_block_vue__ = __webpack_require__("SLTj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_blocks_document_document_block_vue__ = __webpack_require__("cgbk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_blocks_card_card_block_vue__ = __webpack_require__("f/qq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_blocks_product_product_block_vue__ = __webpack_require__("8aC8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_blocks_slideshow_block_slideshow_block_vue__ = __webpack_require__("v/LG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_blocks_sidecontent_sidecontent_block_vue__ = __webpack_require__("Gxbx");


// Blocks Import

// Dependencies


// Section



// Content






// Structure







// Blocks Key

// Dependencies
// Vue.component("markdown", VueMarkdown);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('vue-headful', __WEBPACK_IMPORTED_MODULE_1_vue_headful___default.a);

// Section
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("header-block", __WEBPACK_IMPORTED_MODULE_2__components_blocks_header_header_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("footer-block", __WEBPACK_IMPORTED_MODULE_3__components_blocks_footer_footer_block_vue__["a" /* default */]);

// Content
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("input-block", __WEBPACK_IMPORTED_MODULE_6__components_blocks_input_input_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("image-block", __WEBPACK_IMPORTED_MODULE_5__components_blocks_image_image_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("vector", __WEBPACK_IMPORTED_MODULE_4__components_blocks_vector_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("loading-block", __WEBPACK_IMPORTED_MODULE_7__components_blocks_loading_loading_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("text-block", __WEBPACK_IMPORTED_MODULE_8__components_blocks_text_text_block_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("button-block", __WEBPACK_IMPORTED_MODULE_9__components_blocks_button_button_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("document-block", __WEBPACK_IMPORTED_MODULE_10__components_blocks_document_document_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("card-block", __WEBPACK_IMPORTED_MODULE_11__components_blocks_card_card_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("product-block", __WEBPACK_IMPORTED_MODULE_12__components_blocks_product_product_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("slideshow-block", __WEBPACK_IMPORTED_MODULE_13__components_blocks_slideshow_block_slideshow_block_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component("side-content-block", __WEBPACK_IMPORTED_MODULE_14__components_blocks_sidecontent_sidecontent_block_vue__["a" /* default */]);

/***/ }),

/***/ "zbtW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.674acb42e670a09a1340.js